var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _path40, _g40, _path41, _g41, _path42, _g42, _path43, _g43, _path44, _g44, _path45, _g45, _path46, _g46, _path47, _g47, _path48, _g48, _path49, _g49, _path50, _g50, _path51, _g51, _path52, _g52, _path53, _g53, _path54, _g54, _path55, _g55, _path56, _g56, _path57, _g57, _path58, _g58, _path59, _g59, _path60, _g60, _path61, _g61, _path62, _g62, _path63, _g63, _path64, _g64, _path65, _g65, _path66, _g66, _path67, _g67, _path68, _g68, _path69, _g69, _path70, _g70, _path71, _g71, _path72, _g72, _path73, _g73, _path74, _g74, _path75, _g75, _path76, _g76, _path77, _g77, _path78, _g78, _path79, _g79, _path80, _g80, _path81, _g81, _path82, _g82, _path83, _g83, _path84, _g84, _path85, _g85, _path86, _g86, _path87, _g87, _path88, _g88, _path89, _g89, _path90, _g90, _path91, _g91, _path92, _g92, _path93, _g93, _path94, _g94, _path95, _g95, _path96, _g96, _path97, _g97, _path98, _g98, _path99, _g99, _path100, _g100, _path101, _g101, _path102, _g102, _path103, _g103, _path104, _g104, _path105, _g105, _path106, _g106, _path107, _g107, _path108, _g108, _path109, _g109, _path110, _g110, _path111, _g111, _path112, _g112, _path113, _g113, _path114, _g114, _path115, _g115, _path116, _g116, _path117, _g117, _path118, _g118, _path119, _g119, _path120, _g120, _path121, _g121, _path122, _g122, _path123, _g123, _path124, _g124, _path125, _g125, _path126, _g126, _path127, _g127, _path128, _g128, _path129, _g129, _path130, _g130, _path131, _g131, _path132, _g132, _path133, _g133, _path134, _g134, _path135, _g135, _path136, _g136, _path137, _g137, _path138, _g138, _path139, _g139, _path140, _g140, _path141, _g141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRe7 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 37,
    viewBox: "0 0 150 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.33 2.57777C19.4428 2.57777 19.5555 2.46507 19.5555 2.23957V2.12677C19.5555 1.90127 19.5555 1.78857 19.33 1.78857C19.2173 1.78857 19.1045 1.90127 19.1045 2.12677V2.23957C19.1045 2.46507 19.2173 2.57777 19.33 2.57777ZM19.2173 2.23957C19.33 2.12677 19.33 2.23957 19.33 2.23957C19.4428 2.23957 19.33 2.35227 19.2173 2.23957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.33 1.1123C19.4428 1.1123 19.5555 0.999498 19.5555 0.773998V0.661298C19.5555 0.435798 19.5555 0.322998 19.33 0.322998C19.2173 0.322998 19.1045 0.435798 19.1045 0.661298V0.773998C19.1045 0.999498 19.2173 1.1123 19.33 1.1123ZM19.2173 0.773998C19.2173 0.661298 19.2173 0.661298 19.2173 0.773998C19.33 0.661298 19.33 0.773998 19.33 0.773998C19.4428 0.773998 19.33 0.773998 19.2173 0.773998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2177 34.0348C19.3305 34.0348 19.4432 33.9221 19.4432 33.6966V33.5838C19.4432 33.3584 19.4432 33.2456 19.2177 33.2456C19.105 33.2456 18.9922 33.3584 18.9922 33.5838V33.6966C19.105 33.9221 19.105 34.0348 19.2177 34.0348ZM19.2177 33.6966C19.3305 33.5839 19.3305 33.6966 19.3305 33.6966C19.3305 33.8093 19.3305 33.8093 19.2177 33.6966C19.2177 33.8093 19.2177 33.8093 19.2177 33.6966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.33 20.6176C19.4428 20.6176 19.5555 20.5049 19.5555 20.2794V20.1666C19.5555 19.9411 19.5555 19.8284 19.33 19.8284C19.1045 19.8284 19.1045 19.9411 19.1045 20.1666V20.2794C19.1045 20.5049 19.1045 20.6176 19.33 20.6176ZM19.2173 20.1666C19.33 20.0539 19.33 20.1666 19.33 20.1666C19.33 20.2794 19.33 20.2794 19.2173 20.1666C19.2173 20.2794 19.2173 20.2794 19.2173 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.33 22.083C19.4428 22.083 19.5555 21.9702 19.5555 21.7447V21.632C19.5555 21.4065 19.5555 21.2937 19.33 21.2937C19.2173 21.2937 19.1045 21.4065 19.1045 21.632V21.7447C19.1045 21.9702 19.1045 22.083 19.33 22.083ZM19.2173 21.7447C19.2173 21.632 19.2173 21.632 19.2173 21.7447C19.33 21.632 19.33 21.7447 19.33 21.7447C19.33 21.7447 19.33 21.7447 19.2173 21.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2177 35.6127C19.3305 35.6127 19.4432 35.5 19.4432 35.2745V35.1617C19.4432 34.9362 19.4432 34.8235 19.2177 34.8235C19.105 34.8235 18.9922 34.9362 18.9922 35.1617V35.2745C19.105 35.5 19.105 35.6127 19.2177 35.6127ZM19.2177 35.1617C19.3305 35.049 19.3305 35.1617 19.3305 35.1617C19.3305 35.2745 19.3305 35.2745 19.2177 35.1617C19.2177 35.2745 19.2177 35.2745 19.2177 35.1617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4432 24.7894V24.6766C19.4432 24.4511 19.4432 24.3384 19.2177 24.3384C19.105 24.3384 18.9922 24.4511 18.9922 24.6766V24.7894C18.9922 25.0149 18.9922 25.1276 19.2177 25.1276C19.4432 25.1276 19.4432 25.0149 19.4432 24.7894ZM19.2177 24.7894C19.2177 24.6766 19.2177 24.6766 19.2177 24.7894C19.3305 24.6766 19.3305 24.6766 19.3305 24.7894C19.3305 24.7894 19.3305 24.7894 19.2177 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 7.08754C18.3152 7.08754 18.428 6.97474 18.428 6.74934V6.63654C18.428 6.41104 18.4279 6.29834 18.2024 6.29834C18.0897 6.29834 17.9771 6.41104 17.9771 6.63654V6.74934C18.0898 6.97474 18.0897 7.08754 18.2024 7.08754ZM18.2024 6.74934C18.2024 6.63654 18.2024 6.63654 18.2024 6.74934C18.3152 6.63654 18.3153 6.74934 18.3153 6.74934C18.3153 6.74934 18.3152 6.86204 18.2024 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 13.0634C20.4578 13.0634 20.5706 12.9507 20.5706 12.7252V12.6124C20.5706 12.3869 20.5706 12.2742 20.3451 12.2742C20.2323 12.2742 20.1196 12.3869 20.1196 12.6124V12.7252C20.1196 12.9507 20.2323 13.0634 20.3451 13.0634ZM20.2323 12.7252C20.3451 12.6124 20.3451 12.7252 20.3451 12.7252C20.4578 12.7252 20.4578 12.8379 20.2323 12.7252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5555 11.2591V11.1464C19.5555 10.9209 19.5555 10.8081 19.33 10.8081C19.2173 10.8081 19.1045 10.9209 19.1045 11.1464V11.2591C19.1045 11.4846 19.1045 11.5974 19.33 11.5974C19.4428 11.5974 19.5555 11.4846 19.5555 11.2591ZM19.2173 11.2591C19.2173 11.1464 19.2173 11.1464 19.2173 11.2591C19.33 11.1464 19.33 11.1464 19.33 11.2591C19.4428 11.2591 19.33 11.2591 19.2173 11.2591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5555 15.7691V15.6564C19.5555 15.4309 19.5555 15.3181 19.33 15.3181C19.2173 15.3181 19.1045 15.4309 19.1045 15.6564V15.7691C19.1045 15.9946 19.1045 16.1074 19.33 16.1074C19.4428 16.1074 19.5555 15.9946 19.5555 15.7691ZM19.2173 15.7691C19.2173 15.6564 19.2173 15.6564 19.2173 15.7691C19.33 15.6564 19.33 15.6564 19.33 15.7691C19.33 15.7691 19.33 15.7691 19.2173 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 25.1276C20.4578 25.1276 20.5706 25.0149 20.5706 24.7894V24.6766C20.5706 24.4511 20.5706 24.3384 20.3451 24.3384C20.2323 24.3384 20.1196 24.4511 20.1196 24.6766V24.7894C20.1196 25.0149 20.2323 25.1276 20.3451 25.1276ZM20.2323 24.6766C20.3451 24.5639 20.3451 24.6766 20.3451 24.6766C20.4578 24.7894 20.3451 24.7894 20.2323 24.6766C20.2323 24.7894 20.2323 24.7894 20.2323 24.6766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 23.5497C20.4578 23.5497 20.5706 23.437 20.5706 23.2115V23.0987C20.5706 22.8732 20.5706 22.7605 20.3451 22.7605C20.2323 22.7605 20.1196 22.8732 20.1196 23.0987V23.3242C20.1196 23.437 20.2323 23.5497 20.3451 23.5497ZM20.2323 23.2115C20.3451 23.0987 20.3451 23.2115 20.3451 23.2115C20.4578 23.3242 20.3451 23.3242 20.2323 23.2115C20.2323 23.3242 20.2323 23.3242 20.2323 23.2115Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 10.132C16.286 10.132 16.3988 10.0193 16.3988 9.79377V9.68097C16.3988 9.45547 16.3988 9.34277 16.1733 9.34277C16.0605 9.34277 15.9478 9.45547 15.9478 9.68097V9.79377C15.9478 10.0193 16.0605 10.132 16.1733 10.132ZM16.0605 9.68097C16.1733 9.56827 16.1733 9.68097 16.1733 9.68097C16.286 9.79377 16.286 9.79377 16.0605 9.68097C16.1733 9.79377 16.0605 9.79377 16.0605 9.68097Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 19.0397C18.3152 19.0397 18.428 18.927 18.428 18.7015V18.5888C18.428 18.3633 18.4279 18.2505 18.2024 18.2505C18.0897 18.2505 17.9771 18.3633 17.9771 18.5888V18.8143C18.0898 18.927 18.0897 19.0397 18.2024 19.0397ZM18.2024 18.7015C18.3152 18.5888 18.3153 18.7015 18.3153 18.7015C18.3153 18.8143 18.3152 18.8143 18.2024 18.7015C18.2024 18.8143 18.2024 18.8143 18.2024 18.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 20.6176C18.3152 20.6176 18.428 20.5049 18.428 20.2794V20.1666C18.428 19.9411 18.4279 19.8284 18.2024 19.8284C18.0897 19.8284 17.9771 19.9411 17.9771 20.1666V20.2794C18.0898 20.5049 18.0897 20.6176 18.2024 20.6176ZM18.2024 20.1666C18.3152 20.0539 18.3153 20.1666 18.3153 20.1666C18.3153 20.2794 18.3152 20.2794 18.2024 20.1666C18.2024 20.2794 18.2024 20.2794 18.2024 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 22.083C18.3152 22.083 18.428 21.9702 18.428 21.7447V21.632C18.428 21.4065 18.4279 21.2937 18.2024 21.2937C18.0897 21.2937 17.9771 21.4065 17.9771 21.632V21.7447C18.0898 21.9702 18.0897 22.083 18.2024 22.083ZM18.2024 21.7447C18.2024 21.632 18.2024 21.632 18.2024 21.7447C18.3152 21.632 18.3153 21.7447 18.3153 21.7447C18.3153 21.7447 18.3152 21.7447 18.2024 21.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 10.132C20.4578 10.132 20.5706 10.0193 20.5706 9.79377V9.68097C20.5706 9.45547 20.5706 9.34277 20.3451 9.34277C20.2323 9.34277 20.1196 9.45547 20.1196 9.68097V9.79377C20.1196 10.0193 20.2323 10.132 20.3451 10.132ZM20.2323 9.68097C20.3451 9.56827 20.3451 9.68097 20.3451 9.68097C20.4578 9.79377 20.4578 9.79377 20.2323 9.68097C20.3451 9.79377 20.2323 9.79377 20.2323 9.68097Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 28.0595C18.3152 28.0595 18.428 27.9468 18.428 27.7213V27.6085C18.428 27.383 18.4279 27.2703 18.2024 27.2703C18.0897 27.2703 17.9771 27.383 17.9771 27.6085V27.834C18.0898 27.9468 18.0897 28.0595 18.2024 28.0595ZM18.2024 27.7213C18.3152 27.6085 18.3153 27.7213 18.3153 27.7213C18.3153 27.7213 18.3152 27.834 18.2024 27.7213Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 25.1276C16.286 25.1276 16.3988 25.0149 16.3988 24.7894V24.6766C16.3988 24.4511 16.3988 24.3384 16.1733 24.3384C16.0605 24.3384 15.9478 24.4511 15.9478 24.6766V24.7894C15.9478 25.0149 16.0605 25.1276 16.1733 25.1276ZM16.0605 24.6766C16.1733 24.5639 16.1733 24.6766 16.1733 24.6766C16.286 24.7894 16.1733 24.7894 16.0605 24.6766C16.0605 24.7894 16.0605 24.7894 16.0605 24.6766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 11.5974C16.286 11.5974 16.3988 11.4846 16.3988 11.2591V11.1464C16.3988 10.9209 16.3988 10.8081 16.1733 10.8081C16.0605 10.8081 15.9478 10.9209 15.9478 11.1464V11.2591C15.9478 11.4846 16.0605 11.5974 16.1733 11.5974ZM16.0605 11.2591C16.1733 11.1464 16.0605 11.1464 16.0605 11.2591C16.1733 11.1464 16.1733 11.2591 16.1733 11.2591C16.286 11.2591 16.286 11.2591 16.0605 11.2591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 13.0634C18.3152 13.0634 18.428 12.9507 18.428 12.7252V12.6124C18.428 12.3869 18.4279 12.2742 18.2024 12.2742C18.0897 12.2742 17.9771 12.3869 17.9771 12.6124V12.7252C18.0898 12.9507 18.0897 13.0634 18.2024 13.0634ZM18.2024 12.7252C18.3152 12.6124 18.3153 12.7252 18.3153 12.7252C18.3153 12.7252 18.3152 12.8379 18.2024 12.7252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2177 31.1027C19.3305 31.1027 19.4432 30.99 19.4432 30.7645V30.6517C19.4432 30.4262 19.4432 30.3135 19.2177 30.3135C19.105 30.3135 18.9922 30.4262 18.9922 30.6517V30.7645C19.105 30.99 19.105 31.1027 19.2177 31.1027ZM19.2177 30.6517C19.3305 30.539 19.3305 30.6517 19.3305 30.6517C19.3305 30.7645 19.3305 30.7645 19.2177 30.6517C19.2177 30.7645 19.2177 30.7645 19.2177 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 8.55322C18.3152 8.55322 18.428 8.44041 18.428 8.21491V8.10221C18.428 7.87671 18.4279 7.76392 18.2024 7.76392C18.0897 7.76392 17.9771 7.87671 17.9771 8.10221V8.21491C18.0898 8.44041 18.0897 8.55322 18.2024 8.55322ZM18.2024 8.21491C18.3152 8.10221 18.3153 8.21491 18.3153 8.21491C18.3153 8.32771 18.3152 8.32771 18.2024 8.21491C18.2024 8.32771 18.2024 8.32771 18.2024 8.21491Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2177 29.5249C19.3305 29.5249 19.4432 29.4121 19.4432 29.1866V29.0739C19.4432 28.8484 19.4432 28.7356 19.2177 28.7356C19.105 28.7356 18.9922 28.8484 18.9922 29.0739V29.1866C19.105 29.4121 19.105 29.5249 19.2177 29.5249ZM19.2177 29.1866C19.3305 29.0739 19.3305 29.1866 19.3305 29.1866C19.3305 29.2994 19.3305 29.2994 19.2177 29.1866C19.2177 29.2994 19.2177 29.2994 19.2177 29.1866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 14.642C18.3152 14.642 18.428 14.5293 18.428 14.3038V14.191C18.428 13.9655 18.4279 13.8528 18.2024 13.8528C18.0897 13.8528 17.9771 13.9655 17.9771 14.191V14.3038C18.0898 14.5293 18.0897 14.642 18.2024 14.642ZM18.2024 14.191C18.3152 14.0783 18.3153 14.191 18.3153 14.191C18.3153 14.3038 18.3152 14.3038 18.2024 14.191C18.2024 14.3038 18.2024 14.3038 18.2024 14.191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 1.1123C18.3152 1.1123 18.428 0.999498 18.428 0.773998V0.661298C18.428 0.435798 18.4279 0.322998 18.2024 0.322998C18.0897 0.322998 17.9771 0.435798 17.9771 0.661298V0.773998C18.0898 0.999498 18.0897 1.1123 18.2024 1.1123ZM18.2024 0.773998C18.2024 0.661298 18.2024 0.661298 18.2024 0.773998C18.3152 0.661298 18.3153 0.773998 18.3153 0.773998C18.3153 0.773998 18.3152 0.773998 18.2024 0.773998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3896 31.1027C23.5024 31.1027 23.6151 30.99 23.6151 30.7645V30.6517C23.6151 30.4262 23.6151 30.3135 23.3896 30.3135C23.2769 30.3135 23.1641 30.4262 23.1641 30.6517V30.7645C23.2769 30.99 23.2769 31.1027 23.3896 31.1027ZM23.3896 30.6517C23.5024 30.539 23.5023 30.6517 23.5023 30.6517C23.5023 30.7645 23.5024 30.7645 23.3896 30.6517C23.3896 30.7645 23.3896 30.7645 23.3896 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5019 20.6176C23.6147 20.6176 23.7274 20.5049 23.7274 20.2794V20.1666C23.7274 19.9411 23.7274 19.8284 23.5019 19.8284C23.3892 19.8284 23.2764 19.9411 23.2764 20.1666V20.2794C23.2764 20.5049 23.2764 20.6176 23.5019 20.6176ZM23.3892 20.1666C23.5019 20.0539 23.5019 20.1666 23.5019 20.1666C23.5019 20.2794 23.5019 20.2794 23.3892 20.1666C23.3892 20.2794 23.3892 20.2794 23.3892 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5706 3.81868V3.70588C20.5706 3.48038 20.5706 3.36768 20.3451 3.36768C20.2323 3.36768 20.1196 3.48038 20.1196 3.70588V3.81868C20.1196 4.04418 20.1196 4.15688 20.3451 4.15688C20.4578 4.04418 20.5706 3.93138 20.5706 3.81868ZM20.2323 3.70588C20.3451 3.59318 20.3451 3.59318 20.3451 3.70588C20.4578 3.81868 20.4578 3.81868 20.2323 3.70588C20.3451 3.81868 20.2323 3.81868 20.2323 3.70588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 35.6127C21.4731 35.6127 21.5858 35.5 21.5858 35.2745V35.1617C21.5858 34.9362 21.5858 34.8235 21.3603 34.8235C21.1348 34.8235 21.1348 34.9362 21.1348 35.1617V35.2745C21.1348 35.5 21.2476 35.6127 21.3603 35.6127ZM21.2476 35.1617C21.3603 35.049 21.3603 35.1617 21.3603 35.1617C21.4731 35.2745 21.3603 35.2745 21.2476 35.1617C21.2476 35.2745 21.2476 35.2745 21.2476 35.1617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 23.5497C16.286 23.5497 16.3988 23.437 16.3988 23.2115V23.0987C16.3988 22.8732 16.3988 22.7605 16.1733 22.7605C16.0605 22.7605 15.9478 22.8732 15.9478 23.0987V23.3242C15.9478 23.437 16.0605 23.5497 16.1733 23.5497ZM16.0605 23.2115C16.1733 23.0987 16.1733 23.2115 16.1733 23.2115C16.286 23.3242 16.1733 23.3242 16.0605 23.2115C16.0605 23.3242 16.0605 23.3242 16.0605 23.2115Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3896 29.5249C23.5024 29.5249 23.6151 29.4121 23.6151 29.1866V29.0739C23.6151 28.8484 23.6151 28.7356 23.3896 28.7356C23.2769 28.7356 23.1641 28.8484 23.1641 29.0739V29.1866C23.2769 29.4121 23.2769 29.5249 23.3896 29.5249ZM23.3896 29.1866C23.5024 29.0739 23.5023 29.1866 23.5023 29.1866C23.5023 29.2994 23.5024 29.2994 23.3896 29.1866C23.3896 29.2994 23.3896 29.2994 23.3896 29.1866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 34.0348C21.4731 34.0348 21.5858 33.9221 21.5858 33.6966V33.5838C21.5858 33.3584 21.5858 33.2456 21.3603 33.2456C21.1348 33.2456 21.1348 33.4711 21.1348 33.6966V33.8093C21.1348 33.9221 21.2476 34.0348 21.3603 34.0348ZM21.2476 33.6966C21.3603 33.5839 21.3603 33.6966 21.3603 33.6966C21.4731 33.8093 21.3603 33.8093 21.2476 33.6966C21.2476 33.8093 21.2476 33.8093 21.2476 33.6966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5706 6.74934V6.63654C20.5706 6.41104 20.5706 6.29834 20.3451 6.29834C20.2323 6.29834 20.1196 6.41104 20.1196 6.63654V6.74934C20.1196 6.97474 20.1196 7.08754 20.3451 7.08754C20.4578 7.08754 20.5706 6.97474 20.5706 6.74934ZM20.2323 6.74934C20.3451 6.63654 20.2323 6.63654 20.2323 6.74934C20.3451 6.63654 20.3451 6.63654 20.3451 6.74934C20.4578 6.74934 20.4578 6.86204 20.2323 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5706 17.3482V17.2355C20.5706 17.01 20.5706 16.8972 20.3451 16.8972C20.2323 16.8972 20.1196 17.01 20.1196 17.2355V17.3482C20.1196 17.5737 20.1196 17.6865 20.3451 17.6865C20.4578 17.5737 20.5706 17.461 20.5706 17.3482ZM20.2323 17.2355C20.3451 17.1227 20.3451 17.1227 20.3451 17.2355C20.4578 17.2355 20.3451 17.3482 20.2323 17.2355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5858 5.28401V5.17131C21.5858 4.94581 21.5858 4.83301 21.3603 4.83301C21.2476 4.83301 21.1348 4.94581 21.1348 5.17131V5.28401C21.1348 5.50951 21.1348 5.62231 21.3603 5.62231C21.5858 5.62231 21.5858 5.50951 21.5858 5.28401ZM21.3603 5.28401C21.3603 5.17131 21.3603 5.17131 21.3603 5.28401C21.4731 5.17131 21.4731 5.17131 21.4731 5.28401C21.4731 5.28401 21.4731 5.28401 21.3603 5.28401Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5858 24.7894V24.6766C21.5858 24.4511 21.5858 24.3384 21.3603 24.3384C21.2476 24.3384 21.1348 24.4511 21.1348 24.6766V24.7894C21.1348 25.0149 21.1348 25.1276 21.3603 25.1276C21.4731 25.1276 21.5858 25.0149 21.5858 24.7894ZM21.2476 24.7894C21.3603 24.6766 21.2476 24.6766 21.2476 24.7894C21.3603 24.6766 21.3603 24.6766 21.3603 24.7894C21.4731 24.7894 21.4731 24.7894 21.2476 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 31.1027C22.4872 31.1027 22.5999 30.99 22.5999 30.7645V30.6517C22.5999 30.4262 22.5999 30.3135 22.3744 30.3135C22.2617 30.3135 22.1489 30.4262 22.1489 30.6517V30.7645C22.2617 30.99 22.2617 31.1027 22.3744 31.1027ZM22.3744 30.6517C22.4872 30.539 22.4872 30.6517 22.4872 30.6517C22.4872 30.7645 22.4872 30.7645 22.3744 30.6517C22.3744 30.7645 22.3744 30.7645 22.3744 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 32.5692C22.4872 32.5692 22.5999 32.4564 22.5999 32.2309V32.1182C22.5999 31.8927 22.5999 31.78 22.3744 31.78C22.2617 31.78 22.1489 31.8927 22.1489 32.1182V32.3437C22.2617 32.4564 22.2617 32.5692 22.3744 32.5692ZM22.3744 32.2309C22.3744 32.1182 22.3744 32.1182 22.3744 32.2309C22.4872 32.1182 22.4872 32.2309 22.4872 32.2309C22.4872 32.2309 22.4872 32.3437 22.3744 32.2309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5858 15.7691V15.6564C21.5858 15.4309 21.5858 15.3181 21.3603 15.3181C21.2476 15.3181 21.1348 15.4309 21.1348 15.6564V15.7691C21.1348 15.9946 21.1348 16.1074 21.3603 16.1074C21.4731 16.1074 21.5858 15.9946 21.5858 15.7691ZM21.3603 15.7691C21.3603 15.6564 21.3603 15.6564 21.3603 15.7691C21.4731 15.6564 21.4731 15.6564 21.4731 15.7691C21.4731 15.7691 21.4731 15.7691 21.3603 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5858 11.2591V11.1464C21.5858 10.9209 21.5858 10.8081 21.3603 10.8081C21.2476 10.8081 21.1348 10.9209 21.1348 11.1464V11.2591C21.1348 11.4846 21.1348 11.5974 21.3603 11.5974C21.5858 11.5974 21.5858 11.4846 21.5858 11.2591ZM21.3603 11.2591C21.3603 11.1464 21.3603 11.1464 21.3603 11.2591C21.4731 11.1464 21.4731 11.1464 21.4731 11.2591C21.4731 11.2591 21.4731 11.2591 21.3603 11.2591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 34.0348C20.4578 34.0348 20.5706 33.9221 20.5706 33.6966V33.5838C20.5706 33.3584 20.5706 33.2456 20.3451 33.2456C20.2323 33.2456 20.1196 33.3584 20.1196 33.5838V33.6966C20.1196 33.9221 20.1196 34.0348 20.3451 34.0348ZM20.2323 33.6966C20.3451 33.5839 20.3451 33.6966 20.3451 33.6966C20.3451 33.8093 20.3451 33.8093 20.2323 33.6966C20.2323 33.8093 20.2323 33.8093 20.2323 33.6966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 31.1027C21.4731 31.1027 21.5858 30.99 21.5858 30.7645V30.6517C21.5858 30.4262 21.5858 30.3135 21.3603 30.3135C21.1348 30.3135 21.1348 30.4262 21.1348 30.6517V30.7645C21.1348 30.99 21.2476 31.1027 21.3603 31.1027ZM21.2476 30.6517C21.3603 30.539 21.3603 30.6517 21.3603 30.6517C21.4731 30.7645 21.3603 30.7645 21.2476 30.6517C21.2476 30.7645 21.2476 30.7645 21.2476 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 11.5974C20.4578 11.5974 20.5706 11.4846 20.5706 11.2591V11.1464C20.5706 10.9209 20.5706 10.8081 20.3451 10.8081C20.2323 10.8081 20.1196 10.9209 20.1196 11.1464V11.2591C20.1196 11.4846 20.2323 11.5974 20.3451 11.5974ZM20.2323 11.2591C20.3451 11.1464 20.2323 11.1464 20.2323 11.2591C20.3451 11.1464 20.3451 11.2591 20.3451 11.2591C20.4578 11.2591 20.4578 11.2591 20.2323 11.2591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5555 5.28401V5.17131C19.5555 4.94581 19.5555 4.83301 19.33 4.83301C19.2173 4.83301 19.1045 4.94581 19.1045 5.17131V5.28401C19.1045 5.50951 19.1045 5.62231 19.33 5.62231C19.4428 5.62231 19.5555 5.50951 19.5555 5.28401ZM19.2173 5.28401C19.2173 5.17131 19.2173 5.17131 19.2173 5.28401C19.33 5.17131 19.33 5.17131 19.33 5.28401C19.4428 5.28401 19.33 5.28401 19.2173 5.28401Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 32.5692C20.4578 32.5692 20.5706 32.4564 20.5706 32.2309V32.1182C20.5706 31.8927 20.5706 31.78 20.3451 31.78C20.2323 31.78 20.1196 31.8927 20.1196 32.1182V32.3437C20.1196 32.4564 20.1196 32.5692 20.3451 32.5692ZM20.2323 32.2309C20.2323 32.1182 20.2323 32.1182 20.2323 32.2309C20.3451 32.1182 20.3451 32.2309 20.3451 32.2309C20.3451 32.2309 20.3451 32.3437 20.2323 32.2309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 29.5249C21.4731 29.5249 21.5858 29.4121 21.5858 29.1866V29.0739C21.5858 28.8484 21.5858 28.7356 21.3603 28.7356C21.1348 28.7356 21.1348 28.9611 21.1348 29.1866V29.2994C21.1348 29.4121 21.2476 29.5249 21.3603 29.5249ZM21.2476 29.1866C21.3603 29.0739 21.3603 29.1866 21.3603 29.1866C21.4731 29.2994 21.3603 29.2994 21.2476 29.1866C21.2476 29.2994 21.2476 29.2994 21.2476 29.1866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3451 27.3828C20.2323 27.3828 20.1196 27.4956 20.1196 27.7211V27.8338C20.1196 28.0593 20.1196 28.172 20.3451 28.172C20.4578 28.172 20.5706 28.0593 20.5706 27.8338V27.7211C20.5706 27.4956 20.4578 27.3828 20.3451 27.3828ZM20.4578 27.7211C20.3451 27.8338 20.3451 27.7211 20.3451 27.7211C20.2323 27.7211 20.2323 27.6083 20.4578 27.7211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 1.1123C21.4731 1.1123 21.5858 0.999498 21.5858 0.773998V0.661298C21.5858 0.435798 21.5858 0.322998 21.3603 0.322998C21.1348 0.322998 21.1348 0.435798 21.1348 0.661298V0.773998C21.2476 0.999498 21.2476 1.1123 21.3603 1.1123ZM21.3603 0.773998C21.3603 0.661298 21.3603 0.661298 21.3603 0.773998C21.4731 0.661298 21.4731 0.773998 21.4731 0.773998C21.4731 0.773998 21.4731 0.773998 21.3603 0.773998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5999 27.8338V27.7211C22.5999 27.4956 22.5999 27.3828 22.3744 27.3828C22.2617 27.3828 22.1489 27.4956 22.1489 27.7211V27.8338C22.1489 28.0593 22.1489 28.172 22.3744 28.172C22.5999 28.0593 22.5999 27.9466 22.5999 27.8338ZM22.3744 27.7211C22.4872 27.6083 22.4872 27.6083 22.4872 27.7211C22.4872 27.7211 22.4872 27.8338 22.3744 27.7211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5706 20.2794V20.1666C20.5706 19.9411 20.5706 19.8284 20.3451 19.8284C20.2323 19.8284 20.1196 19.9411 20.1196 20.1666V20.2794C20.1196 20.5049 20.1196 20.6176 20.3451 20.6176C20.4578 20.6176 20.5706 20.5049 20.5706 20.2794ZM20.2323 20.2794C20.2323 20.1666 20.2323 20.1666 20.2323 20.2794C20.3451 20.1666 20.3451 20.1666 20.3451 20.2794C20.4578 20.2794 20.3451 20.2794 20.2323 20.2794Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 20.6176C21.4731 20.6176 21.5858 20.5049 21.5858 20.2794V20.1666C21.5858 19.9411 21.5858 19.8284 21.3603 19.8284C21.2476 19.8284 21.1348 19.9411 21.1348 20.1666V20.2794C21.1348 20.5049 21.2476 20.6176 21.3603 20.6176ZM21.2476 20.1666C21.3603 20.0539 21.3603 20.1666 21.3603 20.1666C21.4731 20.2794 21.4731 20.2794 21.2476 20.1666C21.3603 20.2794 21.2476 20.2794 21.2476 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4583 29.2989V29.1862C20.4583 28.9607 20.4583 28.8479 20.2328 28.8479C20.12 28.8479 20.0073 28.9607 20.0073 29.1862V29.2989C20.0073 29.5244 20.0073 29.6372 20.2328 29.6372C20.4583 29.5244 20.4583 29.4117 20.4583 29.2989ZM20.2328 29.1862C20.3455 29.0734 20.3455 29.0734 20.3455 29.1862C20.3455 29.2989 20.3455 29.2989 20.2328 29.1862C20.2328 29.2989 20.2328 29.2989 20.2328 29.1862Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 22.083C21.4731 22.083 21.5858 21.9702 21.5858 21.7447V21.632C21.5858 21.4065 21.5858 21.2937 21.3603 21.2937C21.1348 21.2937 21.1348 21.5192 21.1348 21.632V21.7447C21.1348 21.9702 21.2476 22.083 21.3603 22.083ZM21.2476 21.7447C21.3603 21.632 21.2476 21.632 21.2476 21.7447C21.3603 21.632 21.3603 21.7447 21.3603 21.7447C21.4731 21.7447 21.4731 21.7447 21.2476 21.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 2.57777C21.4731 2.57777 21.5858 2.46507 21.5858 2.23957V2.12677C21.5858 1.90127 21.5858 1.78857 21.3603 1.78857C21.2476 1.78857 21.1348 1.90127 21.1348 2.12677V2.23957C21.2476 2.46507 21.2476 2.57777 21.3603 2.57777ZM21.3603 2.23957C21.4731 2.12677 21.4731 2.23957 21.4731 2.23957C21.4731 2.23957 21.4731 2.35227 21.3603 2.23957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 11.2591V11.1464C15.3846 10.9209 15.3846 10.8081 15.1591 10.8081C15.0464 10.8081 14.9336 10.9209 14.9336 11.1464V11.2591C14.9336 11.4846 14.9336 11.5974 15.1591 11.5974C15.2719 11.5974 15.3846 11.4846 15.3846 11.2591ZM15.0464 11.2591C15.0464 11.1464 15.0464 11.1464 15.0464 11.2591C15.1591 11.1464 15.1591 11.1464 15.1591 11.2591C15.2719 11.2591 15.1591 11.2591 15.0464 11.2591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 7.08754C14.2567 7.08754 14.3695 6.97474 14.3695 6.74934V6.63654C14.3695 6.41104 14.3695 6.29834 14.144 6.29834C14.0312 6.29834 13.9185 6.41104 13.9185 6.63654V6.74934C13.9185 6.97474 13.9185 7.08754 14.144 7.08754ZM14.0313 6.74934C14.0313 6.63654 14.0313 6.63654 14.0313 6.74934C14.144 6.63654 14.144 6.74934 14.144 6.74934C14.144 6.74934 14.144 6.86204 14.0313 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 5.28401V5.17131C15.3846 4.94581 15.3846 4.83301 15.1591 4.83301C15.0464 4.83301 14.9336 4.94581 14.9336 5.17131V5.28401C14.9336 5.50951 14.9336 5.62231 15.1591 5.62231C15.2719 5.62231 15.3846 5.50951 15.3846 5.28401ZM15.0464 5.28401C15.0464 5.17131 15.0464 5.17131 15.0464 5.28401C15.1591 5.17131 15.1591 5.17131 15.1591 5.28401C15.2719 5.28401 15.1591 5.28401 15.0464 5.28401Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0458 35.6127C15.1586 35.6127 15.2713 35.5 15.2713 35.2745V35.1617C15.2713 34.9362 15.2713 34.8235 15.0458 34.8235C14.9331 34.8235 14.8203 34.9362 14.8203 35.1617V35.2745C14.9331 35.5 14.9331 35.6127 15.0458 35.6127ZM15.0458 35.1617C15.1586 35.049 15.1586 35.1617 15.1586 35.1617C15.1586 35.2745 15.1586 35.2745 15.0458 35.1617C15.0458 35.2745 15.0458 35.2745 15.0458 35.1617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2713 24.7894V24.6766C15.2713 24.4511 15.2713 24.3384 15.0458 24.3384C14.9331 24.3384 14.8203 24.4511 14.8203 24.6766V24.7894C14.8203 25.0149 14.8203 25.1276 15.0458 25.1276C15.2713 25.1276 15.2713 25.0149 15.2713 24.7894ZM15.0458 24.7894C15.0458 24.6766 15.0458 24.6766 15.0458 24.7894C15.1586 24.6766 15.1586 24.6766 15.1586 24.7894C15.1586 24.7894 15.1586 24.7894 15.0458 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0458 34.0348C15.1586 34.0348 15.2713 33.9221 15.2713 33.6966V33.5838C15.2713 33.3584 15.2713 33.2456 15.0458 33.2456C14.9331 33.2456 14.8203 33.3584 14.8203 33.5838V33.6966C14.9331 33.9221 14.9331 34.0348 15.0458 34.0348ZM15.0458 33.6966C15.1586 33.5839 15.1586 33.6966 15.1586 33.6966C15.1586 33.8093 15.1586 33.8093 15.0458 33.6966C15.0458 33.8093 15.0458 33.8093 15.0458 33.6966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3988 6.74934V6.63654C16.3988 6.41104 16.3988 6.29834 16.1733 6.29834C16.0605 6.29834 15.9478 6.41104 15.9478 6.63654V6.74934C15.9478 6.97474 15.9478 7.08754 16.1733 7.08754C16.286 7.08754 16.3988 6.97474 16.3988 6.74934ZM16.1733 6.74934C16.1733 6.63654 16.1733 6.63654 16.1733 6.74934C16.286 6.63654 16.286 6.63654 16.286 6.74934C16.286 6.74934 16.286 6.86204 16.1733 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 27.3828C16.0605 27.3828 15.9478 27.4956 15.9478 27.7211V27.8338C15.9478 28.0593 15.9478 28.172 16.1733 28.172C16.286 28.172 16.3988 28.0593 16.3988 27.8338V27.7211C16.3988 27.4956 16.286 27.3828 16.1733 27.3828ZM16.286 27.7211C16.1733 27.8338 16.1733 27.7211 16.1733 27.7211C16.0605 27.7211 16.0605 27.6083 16.286 27.7211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3988 20.2794V20.1666C16.3988 19.9411 16.3988 19.8284 16.1733 19.8284C16.0605 19.8284 15.9478 19.9411 15.9478 20.1666V20.2794C15.9478 20.5049 15.9478 20.6176 16.1733 20.6176C16.286 20.6176 16.3988 20.5049 16.3988 20.2794ZM16.0605 20.2794C16.1733 20.1666 16.0605 20.1666 16.0605 20.2794C16.1733 20.1666 16.1733 20.1666 16.1733 20.2794C16.286 20.2794 16.286 20.2794 16.0605 20.2794Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3988 17.3482V17.2355C16.3988 17.01 16.3988 16.8972 16.1733 16.8972C16.0605 16.8972 15.9478 17.01 15.9478 17.2355V17.3482C15.9478 17.5737 15.9478 17.6865 16.1733 17.6865C16.286 17.5737 16.3988 17.461 16.3988 17.3482ZM16.0605 17.2355C16.1733 17.1227 16.1733 17.1227 16.1733 17.2355C16.286 17.2355 16.286 17.3482 16.0605 17.2355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2864 29.2989V29.1862C16.2864 28.9607 16.2864 28.8479 16.0609 28.8479C15.9481 28.8479 15.8354 28.9607 15.8354 29.1862V29.2989C15.8354 29.5244 15.8354 29.6372 16.0609 29.6372C16.2864 29.5244 16.2864 29.4117 16.2864 29.2989ZM16.0609 29.1862C16.1736 29.0734 16.1736 29.0734 16.1736 29.1862C16.1736 29.2989 16.1736 29.2989 16.0609 29.1862C16.0609 29.2989 16.0609 29.2989 16.0609 29.1862Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 32.5692C16.286 32.5692 16.3988 32.4564 16.3988 32.2309V32.1182C16.3988 31.8927 16.3988 31.78 16.1733 31.78C16.0605 31.78 15.9478 31.8927 15.9478 32.1182V32.3437C15.9478 32.4564 15.9478 32.5692 16.1733 32.5692ZM16.0605 32.2309C16.0605 32.1182 16.0605 32.1182 16.0605 32.2309C16.1733 32.1182 16.1733 32.2309 16.1733 32.2309C16.1733 32.2309 16.1733 32.3437 16.0605 32.2309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 34.0348C16.286 34.0348 16.3988 33.9221 16.3988 33.6966V33.5838C16.3988 33.3584 16.3988 33.2456 16.1733 33.2456C16.0605 33.2456 15.9478 33.3584 15.9478 33.5838V33.6966C15.9478 33.9221 15.9478 34.0348 16.1733 34.0348ZM16.0605 33.6966C16.1733 33.5839 16.1733 33.6966 16.1733 33.6966C16.1733 33.8093 16.1733 33.8093 16.0605 33.6966C16.0605 33.8093 16.0605 33.8093 16.0605 33.6966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 15.7691V15.6564C15.3846 15.4309 15.3846 15.3181 15.1591 15.3181C15.0464 15.3181 14.9336 15.4309 14.9336 15.6564V15.7691C14.9336 15.9946 14.9336 16.1074 15.1591 16.1074C15.2719 16.1074 15.3846 15.9946 15.3846 15.7691ZM15.0464 15.7691C15.0464 15.6564 15.0464 15.6564 15.0464 15.7691C15.1591 15.6564 15.1591 15.6564 15.1591 15.7691C15.2719 15.7691 15.1591 15.7691 15.0464 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.242 2.3531V2.2404C13.242 2.0149 13.242 1.9021 13.0165 1.9021C12.9037 1.9021 12.791 2.0149 12.791 2.2404V2.3531C12.791 2.5786 12.791 2.6914 13.0165 2.6914C13.242 2.5786 13.242 2.4659 13.242 2.3531ZM13.0165 2.2404C13.1292 2.1276 13.1292 2.1276 13.1292 2.2404C13.1292 2.2404 13.1292 2.3531 13.0165 2.2404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2572 35.2745V35.1617C14.2572 34.9362 14.2572 34.8235 14.0317 34.8235C13.9189 34.8235 13.8062 34.9362 13.8062 35.1617V35.2745C13.8062 35.5 13.8062 35.6127 14.0317 35.6127C14.2572 35.6127 14.2572 35.5 14.2572 35.2745ZM14.0317 35.2745C14.0317 35.1617 14.0317 35.1617 14.0317 35.2745C14.1444 35.1617 14.1444 35.1617 14.1444 35.2745C14.1444 35.2745 14.1444 35.2745 14.0317 35.2745Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 5.62231C13.1292 5.62231 13.242 5.50951 13.242 5.28401V5.17131C13.242 4.94581 13.242 4.83301 13.0165 4.83301C12.9037 4.83301 12.791 4.94581 12.791 5.17131V5.28401C12.9037 5.50951 12.9037 5.62231 13.0165 5.62231ZM13.0165 5.17131C13.1292 5.05851 13.1292 5.17131 13.1292 5.17131C13.1292 5.28401 13.1292 5.28401 13.0165 5.17131C13.0165 5.28401 13.0165 5.28401 13.0165 5.17131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 7.08754C13.1292 7.08754 13.242 6.97474 13.242 6.74934V6.63654C13.242 6.41104 13.242 6.29834 13.0165 6.29834C12.9037 6.29834 12.791 6.41104 12.791 6.63654V6.74934C12.9037 6.97474 12.9037 7.08754 13.0165 7.08754ZM13.0165 6.74934C13.0165 6.63654 13.0165 6.63654 13.0165 6.74934C13.1292 6.63654 13.1292 6.74934 13.1292 6.74934C13.1292 6.74934 13.1292 6.86204 13.0165 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.242 9.79377V9.68097C13.242 9.45547 13.242 9.34277 13.0165 9.34277C12.9037 9.34277 12.791 9.45547 12.791 9.68097V9.79377C12.791 10.0193 12.791 10.132 13.0165 10.132C13.242 10.132 13.242 10.0193 13.242 9.79377ZM13.0165 9.79377C13.0165 9.68097 13.0165 9.68097 13.0165 9.79377C13.1292 9.68097 13.1292 9.68097 13.1292 9.79377C13.1292 9.79377 13.1292 9.79377 13.0165 9.79377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 29.5249C14.2567 29.5249 14.3695 29.4121 14.3695 29.1866V29.0739C14.3695 28.8484 14.3695 28.7356 14.144 28.7356C14.0312 28.7356 13.9185 28.8484 13.9185 29.0739V29.1866C13.9185 29.4121 13.9185 29.5249 14.144 29.5249ZM14.0313 29.1866C14.144 29.0739 14.144 29.1866 14.144 29.1866C14.144 29.2994 14.144 29.2994 14.0313 29.1866C14.0313 29.2994 14.0313 29.2994 14.0313 29.1866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 8.55322C14.2567 8.55322 14.3695 8.44041 14.3695 8.21491V8.10221C14.3695 7.87671 14.3695 7.76392 14.144 7.76392C14.0312 7.76392 13.9185 7.87671 13.9185 8.10221V8.21491C13.9185 8.44041 13.9185 8.55322 14.144 8.55322ZM14.0313 8.21491C14.144 8.10221 14.144 8.21491 14.144 8.21491C14.144 8.32771 14.144 8.32771 14.0313 8.21491C14.0313 8.32771 14.0313 8.32771 14.0313 8.21491Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 22.083C14.2567 22.083 14.3695 21.9702 14.3695 21.7447V21.632C14.3695 21.4065 14.3695 21.2937 14.144 21.2937C14.0312 21.2937 13.9185 21.4065 13.9185 21.632V21.7447C13.9185 21.9702 13.9185 22.083 14.144 22.083ZM14.0313 21.7447C14.0313 21.632 14.0313 21.632 14.0313 21.7447C14.144 21.632 14.144 21.7447 14.144 21.7447C14.144 21.7447 14.144 21.7447 14.0313 21.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 14.642C14.2567 14.642 14.3695 14.5293 14.3695 14.3038V14.191C14.3695 13.9655 14.3695 13.8528 14.144 13.8528C14.0312 13.8528 13.9185 13.9655 13.9185 14.191V14.3038C13.9185 14.5293 13.9185 14.642 14.144 14.642ZM14.0313 14.191C14.144 14.0783 14.144 14.191 14.144 14.191C14.144 14.3038 14.144 14.3038 14.0313 14.191C14.0313 14.3038 14.0313 14.3038 14.0313 14.191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 13.0634C14.2567 13.0634 14.3695 12.9507 14.3695 12.7252V12.6124C14.3695 12.3869 14.3695 12.2742 14.144 12.2742C14.0312 12.2742 13.9185 12.3869 13.9185 12.6124V12.7252C13.9185 12.9507 13.9185 13.0634 14.144 13.0634ZM14.0313 12.7252C14.144 12.6124 14.144 12.7252 14.144 12.7252C14.144 12.7252 14.144 12.8379 14.0313 12.7252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 28.0595C14.2567 28.0595 14.3695 27.9468 14.3695 27.7213V27.6085C14.3695 27.383 14.3695 27.2703 14.144 27.2703C14.0312 27.2703 13.9185 27.383 13.9185 27.6085V27.834C13.9185 27.9468 13.9185 28.0595 14.144 28.0595ZM14.0313 27.7213C14.144 27.6085 14.144 27.7213 14.144 27.7213C14.144 27.7213 14.144 27.834 14.0313 27.7213Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 19.0397C14.2567 19.0397 14.3695 18.927 14.3695 18.7015V18.5888C14.3695 18.3633 14.3695 18.2505 14.144 18.2505C14.0312 18.2505 13.9185 18.3633 13.9185 18.5888V18.8143C13.9185 18.927 13.9185 19.0397 14.144 19.0397ZM14.0313 18.7015C14.144 18.5888 14.144 18.7015 14.144 18.7015C14.144 18.8143 14.144 18.8143 14.0313 18.7015C14.0313 18.8143 14.0313 18.8143 14.0313 18.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 20.6176C14.2567 20.6176 14.3695 20.5049 14.3695 20.2794V20.1666C14.3695 19.9411 14.3695 19.8284 14.144 19.8284C14.0312 19.8284 13.9185 19.9411 13.9185 20.1666V20.2794C13.9185 20.5049 13.9185 20.6176 14.144 20.6176ZM14.0313 20.1666C14.144 20.0539 14.144 20.1666 14.144 20.1666C14.144 20.2794 14.144 20.2794 14.0313 20.1666C14.0313 20.2794 14.0313 20.2794 14.0313 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1884 20.6176C17.3012 20.6176 17.4139 20.5049 17.4139 20.2794V20.1666C17.4139 19.9411 17.4139 19.8284 17.1884 19.8284C17.0757 19.8284 16.9629 19.9411 16.9629 20.1666V20.2794C16.9629 20.5049 17.0757 20.6176 17.1884 20.6176ZM17.1884 20.1666C17.3012 20.0539 17.3012 20.1666 17.3012 20.1666C17.3012 20.2794 17.3012 20.2794 17.1884 20.1666C17.1884 20.2794 17.1884 20.2794 17.1884 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1884 5.62231C17.3012 5.62231 17.4139 5.50951 17.4139 5.28401V5.17131C17.4139 4.94581 17.4139 4.83301 17.1884 4.83301C17.0757 4.83301 16.9629 4.94581 16.9629 5.17131V5.28401C16.9629 5.50951 17.0757 5.62231 17.1884 5.62231ZM17.1884 5.17131C17.3012 5.05851 17.3012 5.17131 17.3012 5.17131C17.3012 5.28401 17.3012 5.28401 17.1884 5.17131C17.1884 5.28401 17.1884 5.28401 17.1884 5.17131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4139 15.7691V15.6564C17.4139 15.4309 17.4139 15.3181 17.1884 15.3181C17.0757 15.3181 16.9629 15.4309 16.9629 15.6564V15.7691C16.9629 15.9946 16.9629 16.1074 17.1884 16.1074C17.3012 16.1074 17.4139 15.9946 17.4139 15.7691ZM17.1884 15.7691C17.1884 15.6564 17.1884 15.6564 17.1884 15.7691C17.3012 15.6564 17.3012 15.6564 17.3012 15.7691C17.3012 15.7691 17.3012 15.7691 17.1884 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0458 31.1027C15.1586 31.1027 15.2713 30.99 15.2713 30.7645V30.6517C15.2713 30.4262 15.2713 30.3135 15.0458 30.3135C14.9331 30.3135 14.8203 30.4262 14.8203 30.6517V30.7645C14.9331 30.99 14.9331 31.1027 15.0458 31.1027ZM15.0458 30.6517C15.1586 30.539 15.1586 30.6517 15.1586 30.6517C15.1586 30.7645 15.1586 30.7645 15.0458 30.6517C15.0458 30.7645 15.0458 30.7645 15.0458 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0458 29.5249C15.1586 29.5249 15.2713 29.4121 15.2713 29.1866V29.0739C15.2713 28.8484 15.2713 28.7356 15.0458 28.7356C14.9331 28.7356 14.8203 28.8484 14.8203 29.0739V29.1866C14.9331 29.4121 14.9331 29.5249 15.0458 29.5249ZM15.0458 29.1866C15.1586 29.0739 15.1586 29.1866 15.1586 29.1866C15.1586 29.2994 15.1586 29.2994 15.0458 29.1866C15.0458 29.2994 15.0458 29.2994 15.0458 29.1866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4139 9.79377V9.68097C17.4139 9.45547 17.4139 9.34277 17.1884 9.34277C17.0757 9.34277 16.9629 9.45547 16.9629 9.68097V9.79377C16.9629 10.0193 16.9629 10.132 17.1884 10.132C17.3012 10.132 17.4139 10.0193 17.4139 9.79377ZM17.1884 9.79377C17.1884 9.68097 17.1884 9.68097 17.1884 9.79377C17.3012 9.68097 17.3012 9.68097 17.3012 9.79377C17.3012 9.79377 17.3012 9.79377 17.1884 9.79377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.144 1.1123C14.2567 1.1123 14.3695 0.999498 14.3695 0.773998V0.661298C14.3695 0.435798 14.3695 0.322998 14.144 0.322998C14.0312 0.322998 13.9185 0.435798 13.9185 0.661298V0.773998C13.9185 0.999498 13.9185 1.1123 14.144 1.1123ZM14.0313 0.773998C14.0313 0.661298 14.0313 0.661298 14.0313 0.773998C14.144 0.661298 14.144 0.773998 14.144 0.773998C14.144 0.773998 14.144 0.773998 14.0313 0.773998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1884 7.08754C17.3012 7.08754 17.4139 6.97474 17.4139 6.74934V6.63654C17.4139 6.41104 17.4139 6.29834 17.1884 6.29834C17.0757 6.29834 16.9629 6.41104 16.9629 6.63654V6.74934C16.9629 6.97474 17.0757 7.08754 17.1884 7.08754ZM17.1884 6.74934C17.1884 6.63654 17.1884 6.63654 17.1884 6.74934C17.3012 6.63654 17.3012 6.74934 17.3012 6.74934C17.3012 6.74934 17.3012 6.86204 17.1884 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1591 2.57777C15.2719 2.57777 15.3846 2.46507 15.3846 2.23957V2.12677C15.3846 1.90127 15.3846 1.78857 15.1591 1.78857C15.0464 1.78857 14.9336 1.90127 14.9336 2.12677V2.23957C14.9336 2.46507 15.0464 2.57777 15.1591 2.57777ZM15.0464 2.23957C15.1591 2.12677 15.1591 2.23957 15.1591 2.23957C15.2719 2.23957 15.2719 2.35227 15.0464 2.23957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1591 20.6176C15.2719 20.6176 15.3846 20.5049 15.3846 20.2794V20.1666C15.3846 19.9411 15.3846 19.8284 15.1591 19.8284C15.0464 19.8284 14.9336 19.9411 14.9336 20.1666V20.2794C14.9336 20.5049 15.0464 20.6176 15.1591 20.6176ZM15.0464 20.1666C15.1591 20.0539 15.1591 20.1666 15.1591 20.1666C15.1591 20.2794 15.1591 20.2794 15.0464 20.1666C15.0464 20.2794 15.0464 20.2794 15.0464 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.428 35.2745V35.1617C18.428 34.9362 18.4279 34.8235 18.2024 34.8235C18.0897 34.8235 17.9771 34.9362 17.9771 35.1617V35.2745C17.9771 35.5 17.977 35.6127 18.2024 35.6127C18.4279 35.6127 18.428 35.5 18.428 35.2745ZM18.2024 35.2745C18.2024 35.1617 18.2024 35.1617 18.2024 35.2745C18.3152 35.1617 18.3153 35.1617 18.3153 35.2745C18.3153 35.2745 18.3152 35.2745 18.2024 35.2745Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1591 1.1123C15.2719 1.1123 15.3846 0.999498 15.3846 0.773998V0.661298C15.3846 0.435798 15.3846 0.322998 15.1591 0.322998C15.0464 0.322998 14.9336 0.435798 14.9336 0.661298V0.773998C14.9336 0.999498 15.0464 1.1123 15.1591 1.1123ZM15.0464 0.773998C15.1591 0.661298 15.0464 0.661298 15.0464 0.773998C15.1591 0.661298 15.1591 0.773998 15.1591 0.773998C15.2719 0.773998 15.2719 0.773998 15.0464 0.773998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4139 2.3531V2.2404C17.4139 2.0149 17.4139 1.9021 17.1884 1.9021C17.0757 1.9021 16.9629 2.0149 16.9629 2.2404V2.3531C16.9629 2.5786 16.9629 2.6914 17.1884 2.6914C17.3012 2.5786 17.4139 2.4659 17.4139 2.3531ZM17.1884 2.2404C17.3012 2.1276 17.3012 2.1276 17.3012 2.2404C17.3012 2.2404 17.3012 2.3531 17.1884 2.2404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1591 22.083C15.2719 22.083 15.3846 21.9702 15.3846 21.7447V21.632C15.3846 21.4065 15.3846 21.2937 15.1591 21.2937C15.0464 21.2937 14.9336 21.4065 14.9336 21.632V21.7447C14.9336 21.9702 15.0464 22.083 15.1591 22.083ZM15.0464 21.7447C15.0464 21.632 15.0464 21.632 15.0464 21.7447C15.1591 21.632 15.1591 21.7447 15.1591 21.7447C15.1591 21.7447 15.1591 21.7447 15.0464 21.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 20.6176C13.1292 20.6176 13.242 20.5049 13.242 20.2794V20.1666C13.242 19.9411 13.242 19.8284 13.0165 19.8284C12.9037 19.8284 12.791 19.9411 12.791 20.1666V20.2794C12.9037 20.5049 12.9037 20.6176 13.0165 20.6176ZM13.0165 20.1666C13.1292 20.0539 13.1292 20.1666 13.1292 20.1666C13.1292 20.2794 13.1292 20.2794 13.0165 20.1666C13.0165 20.2794 13.0165 20.2794 13.0165 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1884 32.5692C17.3012 32.5692 17.4139 32.4564 17.4139 32.2309V32.1182C17.4139 31.8927 17.4139 31.78 17.1884 31.78C17.0757 31.78 16.9629 31.8927 16.9629 32.1182V32.3437C16.9629 32.4564 17.0757 32.5692 17.1884 32.5692ZM17.1884 32.2309C17.1884 32.1182 17.1884 32.1182 17.1884 32.2309C17.3012 32.1182 17.3012 32.2309 17.3012 32.2309C17.3012 32.2309 17.3012 32.3437 17.1884 32.2309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.242 15.7691V15.6564C13.242 15.4309 13.242 15.3181 13.0165 15.3181C12.9037 15.3181 12.791 15.4309 12.791 15.6564V15.7691C12.791 15.9946 12.791 16.1074 13.0165 16.1074C13.242 16.1074 13.242 15.9946 13.242 15.7691ZM13.0165 15.7691C13.0165 15.6564 13.0165 15.6564 13.0165 15.7691C13.1292 15.6564 13.1292 15.6564 13.1292 15.7691C13.1292 15.7691 13.1292 15.7691 13.0165 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.242 24.7894V24.6766C13.242 24.4511 13.242 24.3384 13.0165 24.3384C12.9037 24.3384 12.791 24.4511 12.791 24.6766V24.7894C12.791 25.0149 12.791 25.1276 13.0165 25.1276C13.242 25.1276 13.242 25.0149 13.242 24.7894ZM13.0165 24.7894C13.0165 24.6766 13.0165 24.6766 13.0165 24.7894C13.1292 24.6766 13.1292 24.6766 13.1292 24.7894C13.1292 24.7894 13.1292 24.7894 13.0165 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1884 31.1027C17.3012 31.1027 17.4139 30.99 17.4139 30.7645V30.6517C17.4139 30.4262 17.4139 30.3135 17.1884 30.3135C17.0757 30.3135 16.9629 30.4262 16.9629 30.6517V30.7645C16.9629 30.99 17.0757 31.1027 17.1884 31.1027ZM17.1884 30.6517C17.3012 30.539 17.3012 30.6517 17.3012 30.6517C17.3012 30.7645 17.3012 30.7645 17.1884 30.6517C17.1884 30.7645 17.1884 30.7645 17.1884 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3988 3.81868V3.70588C16.3988 3.48038 16.3988 3.36768 16.1733 3.36768C16.0605 3.36768 15.9478 3.48038 15.9478 3.70588V3.81868C15.9478 4.04418 15.9478 4.15688 16.1733 4.15688C16.286 4.04418 16.3988 3.93138 16.3988 3.81868ZM16.1733 3.70588C16.286 3.59318 16.286 3.59318 16.286 3.70588C16.286 3.81868 16.286 3.81868 16.1733 3.70588C16.1733 3.81868 16.1733 3.81868 16.1733 3.70588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 19.0397C13.1292 19.0397 13.242 18.927 13.242 18.7015V18.5888C13.242 18.3633 13.242 18.2505 13.0165 18.2505C12.9037 18.2505 12.791 18.3633 12.791 18.5888V18.8143C12.9037 18.927 12.9037 19.0397 13.0165 19.0397ZM13.0165 18.7015C13.1292 18.5888 13.1292 18.7015 13.1292 18.7015C13.1292 18.8143 13.1292 18.8143 13.0165 18.7015C13.0165 18.8143 13.0165 18.8143 13.0165 18.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4139 24.7894V24.6766C17.4139 24.4511 17.4139 24.3384 17.1884 24.3384C17.0757 24.3384 16.9629 24.4511 16.9629 24.6766V24.7894C16.9629 25.0149 16.9629 25.1276 17.1884 25.1276C17.3012 25.1276 17.4139 25.0149 17.4139 24.7894ZM17.1884 24.7894C17.1884 24.6766 17.1884 24.6766 17.1884 24.7894C17.3012 24.6766 17.3012 24.6766 17.3012 24.7894C17.3012 24.7894 17.3012 24.7894 17.1884 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2024 29.5249C18.3152 29.5249 18.428 29.4121 18.428 29.1866V29.0739C18.428 28.8484 18.4279 28.7356 18.2024 28.7356C18.0897 28.7356 17.9771 28.8484 17.9771 29.0739V29.1866C18.0898 29.4121 18.0897 29.5249 18.2024 29.5249ZM18.2024 29.1866C18.3152 29.0739 18.3153 29.1866 18.3153 29.1866C18.3153 29.2994 18.3152 29.2994 18.2024 29.1866C18.2024 29.2994 18.2024 29.2994 18.2024 29.1866Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 31.1027C13.1292 31.1027 13.242 30.99 13.242 30.7645V30.6517C13.242 30.4262 13.242 30.3135 13.0165 30.3135C12.9037 30.3135 12.791 30.4262 12.791 30.6517V30.7645C12.9037 30.99 12.9037 31.1027 13.0165 31.1027ZM13.0165 30.6517C13.1292 30.539 13.1292 30.6517 13.1292 30.6517C13.1292 30.7645 13.1292 30.7645 13.0165 30.6517C13.0165 30.7645 13.0165 30.7645 13.0165 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 32.5692C13.1292 32.5692 13.242 32.4564 13.242 32.2309V32.1182C13.242 31.8927 13.242 31.78 13.0165 31.78C12.9037 31.78 12.791 31.8927 12.791 32.1182V32.3437C12.9037 32.4564 12.9037 32.5692 13.0165 32.5692ZM13.0165 32.2309C13.0165 32.1182 13.0165 32.1182 13.0165 32.2309C13.1292 32.1182 13.1292 32.2309 13.1292 32.2309C13.1292 32.2309 13.1292 32.3437 13.0165 32.2309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4139 27.8338V27.7211C17.4139 27.4956 17.4139 27.3828 17.1884 27.3828C17.0757 27.3828 16.9629 27.4956 16.9629 27.7211V27.8338C16.9629 28.0593 16.9629 28.172 17.1884 28.172C17.3012 28.0593 17.4139 27.9466 17.4139 27.8338ZM17.1884 27.7211C17.3012 27.6083 17.3012 27.6083 17.3012 27.7211C17.3012 27.7211 17.3012 27.8338 17.1884 27.7211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.242 27.8338V27.7211C13.242 27.4956 13.242 27.3828 13.0165 27.3828C12.9037 27.3828 12.791 27.4956 12.791 27.7211V27.8338C12.791 28.0593 12.791 28.172 13.0165 28.172C13.242 28.0593 13.242 27.9466 13.242 27.8338ZM13.0165 27.7211C13.1292 27.6083 13.1292 27.6083 13.1292 27.7211C13.1292 27.7211 13.1292 27.8338 13.0165 27.7211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1884 19.0397C17.3012 19.0397 17.4139 18.927 17.4139 18.7015V18.5888C17.4139 18.3633 17.4139 18.2505 17.1884 18.2505C17.0757 18.2505 16.9629 18.3633 16.9629 18.5888V18.8143C16.9629 18.927 17.0757 19.0397 17.1884 19.0397ZM17.1884 18.7015C17.3012 18.5888 17.3012 18.7015 17.3012 18.7015C17.3012 18.8143 17.3012 18.8143 17.1884 18.7015C17.1884 18.8143 17.1884 18.8143 17.1884 18.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1733 13.0634C16.286 13.0634 16.3988 12.9507 16.3988 12.7252V12.6124C16.3988 12.3869 16.3988 12.2742 16.1733 12.2742C16.0605 12.2742 15.9478 12.3869 15.9478 12.6124V12.7252C15.9478 12.9507 16.0605 13.0634 16.1733 13.0634ZM16.0605 12.7252C16.1733 12.6124 16.1733 12.7252 16.1733 12.7252C16.286 12.7252 16.286 12.8379 16.0605 12.7252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5019 2.57777C23.6147 2.57777 23.7274 2.46507 23.7274 2.23957V2.12677C23.7274 1.90127 23.7274 1.78857 23.5019 1.78857C23.2764 1.78857 23.2764 1.90127 23.2764 2.12677V2.23957C23.2764 2.46507 23.3892 2.57777 23.5019 2.57777ZM23.3892 2.23957C23.5019 2.12677 23.5019 2.23957 23.5019 2.23957C23.6147 2.23957 23.5019 2.35227 23.3892 2.23957Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6004 15.7691V15.6564C22.6004 15.4309 22.6004 15.3181 22.3749 15.3181C22.2621 15.3181 22.2622 15.4309 22.2622 15.6564V15.7691C22.2622 15.9946 22.2622 16.1074 22.4876 16.1074C22.6004 16.1074 22.6004 15.9946 22.6004 15.7691ZM22.3749 15.7691C22.3749 15.6564 22.3749 15.6564 22.3749 15.7691C22.4876 15.6564 22.4876 15.6564 22.4876 15.7691C22.4876 15.7691 22.4876 15.7691 22.3749 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5019 1.1123C23.6147 1.1123 23.7274 0.999498 23.7274 0.773998V0.661298C23.7274 0.435798 23.7274 0.322998 23.5019 0.322998C23.3892 0.322998 23.2764 0.435798 23.2764 0.661298V0.773998C23.2764 0.999498 23.3892 1.1123 23.5019 1.1123ZM23.3892 0.773998C23.3892 0.661298 23.3892 0.661298 23.3892 0.773998C23.5019 0.661298 23.5019 0.773998 23.5019 0.773998C23.6147 0.773998 23.5019 0.773998 23.3892 0.773998Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.517 32.5692C24.6298 32.5692 24.7425 32.4564 24.7425 32.2309V32.1182C24.7425 31.8927 24.7425 31.78 24.517 31.78C24.4043 31.78 24.2915 31.8927 24.2915 32.1182V32.3437C24.2915 32.4564 24.4043 32.5692 24.517 32.5692ZM24.4043 32.2309C24.4043 32.1182 24.4043 32.1182 24.4043 32.2309C24.517 32.1182 24.517 32.2309 24.517 32.2309C24.6298 32.2309 24.517 32.3437 24.4043 32.2309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7274 11.2591V11.1464C23.7274 10.9209 23.7274 10.8081 23.5019 10.8081C23.3892 10.8081 23.2764 10.9209 23.2764 11.1464V11.2591C23.2764 11.4846 23.2764 11.5974 23.5019 11.5974C23.6147 11.5974 23.7274 11.4846 23.7274 11.2591ZM23.3892 11.2591C23.3892 11.1464 23.3892 11.1464 23.3892 11.2591C23.5019 11.1464 23.5019 11.1464 23.5019 11.2591C23.5019 11.2591 23.5019 11.2591 23.3892 11.2591Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 19.0397C22.4872 19.0397 22.5999 18.927 22.5999 18.7015V18.5888C22.5999 18.3633 22.5999 18.2505 22.3744 18.2505C22.2617 18.2505 22.1489 18.3633 22.1489 18.5888V18.8143C22.2617 18.927 22.2617 19.0397 22.3744 19.0397ZM22.3744 18.7015C22.4872 18.5888 22.4872 18.7015 22.4872 18.7015C22.4872 18.8143 22.4872 18.8143 22.3744 18.7015C22.3744 18.8143 22.3744 18.8143 22.3744 18.7015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7274 5.28401V5.17131C23.7274 4.94581 23.7274 4.83301 23.5019 4.83301C23.3892 4.83301 23.2764 4.94581 23.2764 5.17131V5.28401C23.2764 5.50951 23.2764 5.62231 23.5019 5.62231C23.6147 5.62231 23.7274 5.50951 23.7274 5.28401ZM23.3892 5.28401C23.3892 5.17131 23.3892 5.17131 23.3892 5.28401C23.5019 5.17131 23.5019 5.17131 23.5019 5.28401C23.6147 5.28401 23.5019 5.28401 23.3892 5.28401Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7425 24.7894V24.6766C24.7425 24.4511 24.7425 24.3384 24.517 24.3384C24.4043 24.3384 24.2915 24.4511 24.2915 24.6766V24.7894C24.2915 25.0149 24.2915 25.1276 24.517 25.1276C24.6298 25.1276 24.7425 25.0149 24.7425 24.7894ZM24.4043 24.7894C24.4043 24.6766 24.4043 24.6766 24.4043 24.7894C24.517 24.6766 24.517 24.6766 24.517 24.7894C24.6298 24.7894 24.517 24.7894 24.4043 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.517 20.6176C24.6298 20.6176 24.7425 20.5049 24.7425 20.2794V20.1666C24.7425 19.9411 24.7425 19.8284 24.517 19.8284C24.4043 19.8284 24.2915 19.9411 24.2915 20.1666V20.2794C24.2915 20.5049 24.4043 20.6176 24.517 20.6176ZM24.4043 20.1666C24.517 20.0539 24.517 20.1666 24.517 20.1666C24.6298 20.2794 24.517 20.2794 24.4043 20.1666C24.4043 20.2794 24.4043 20.2794 24.4043 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6004 2.3531V2.2404C22.6004 2.0149 22.6004 1.9021 22.3749 1.9021C22.2621 1.9021 22.2622 2.0149 22.2622 2.1276V2.2404C22.2622 2.4659 22.2622 2.5786 22.4876 2.5786C22.6004 2.5786 22.6004 2.4659 22.6004 2.3531ZM22.3749 2.2404C22.4876 2.1276 22.4876 2.1276 22.4876 2.2404C22.4876 2.2404 22.4876 2.3531 22.3749 2.2404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7425 9.79377V9.68097C24.7425 9.45547 24.7425 9.34277 24.517 9.34277C24.4043 9.34277 24.2915 9.45547 24.2915 9.68097V9.79377C24.2915 10.0193 24.2915 10.132 24.517 10.132C24.6298 10.132 24.7425 10.0193 24.7425 9.79377ZM24.4043 9.79377C24.4043 9.68097 24.4043 9.68097 24.4043 9.79377C24.517 9.68097 24.517 9.68097 24.517 9.79377C24.6298 9.79377 24.517 9.79377 24.4043 9.79377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3749 20.6176C22.4876 20.6176 22.6004 20.5049 22.6004 20.2794V20.1666C22.6004 19.9411 22.6004 19.8284 22.3749 19.8284C22.2621 19.8284 22.2622 19.9411 22.2622 20.1666V20.2794C22.2622 20.5049 22.2621 20.6176 22.3749 20.6176ZM22.3749 20.1666C22.4876 20.0539 22.4876 20.1666 22.4876 20.1666C22.4876 20.2794 22.4876 20.2794 22.3749 20.1666C22.3749 20.2794 22.3749 20.2794 22.3749 20.1666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.517 31.1027C24.6298 31.1027 24.7425 30.99 24.7425 30.7645V30.6517C24.7425 30.4262 24.7425 30.3135 24.517 30.3135C24.4043 30.3135 24.2915 30.4262 24.2915 30.6517V30.7645C24.2915 30.99 24.4043 31.1027 24.517 31.1027ZM24.4043 30.6517C24.517 30.539 24.517 30.6517 24.517 30.6517C24.6298 30.7645 24.517 30.7645 24.4043 30.6517C24.4043 30.7645 24.4043 30.7645 24.4043 30.6517Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.2041 37.1919H28.5761V-3.17188H-2.2041V37.1919ZM23.5024 0.323275C23.7279 0.323275 23.8407 0.436075 23.8407 0.774275C23.8407 1.11257 23.7279 1.22528 23.5024 1.22528C23.2769 1.22528 23.1642 1.11257 23.1642 0.774275C23.1642 0.436075 23.2769 0.323275 23.5024 0.323275ZM23.5024 1.78907C23.7279 1.78907 23.8407 1.90177 23.8407 2.23997C23.8407 2.57827 23.7279 2.69098 23.5024 2.69098C23.2769 2.69098 23.1642 2.57827 23.1642 2.23997C23.1642 1.90177 23.2769 1.78907 23.5024 1.78907ZM23.5024 21.2945C23.7279 21.2945 23.8407 21.4072 23.8407 21.7454C23.8407 22.0837 23.7279 22.1964 23.5024 22.1964C23.2769 22.1964 23.1642 22.0837 23.1642 21.7454C23.1642 21.4072 23.2769 21.2945 23.5024 21.2945ZM23.1642 20.2797C23.1642 19.9415 23.2769 19.8287 23.5024 19.8287C23.7279 19.8287 23.8407 19.9415 23.8407 20.2797C23.8407 20.618 23.7279 20.7307 23.5024 20.7307C23.2769 20.7307 23.1642 20.5052 23.1642 20.2797ZM23.3897 30.3143C23.6152 30.3143 23.7279 30.427 23.7279 30.7653C23.7279 31.1035 23.6152 31.2163 23.3897 31.2163C23.1642 31.2163 23.0514 31.1035 23.0514 30.7653C23.1642 30.427 23.1642 30.3143 23.3897 30.3143ZM23.1642 29.1868C23.1642 28.8486 23.2769 28.7358 23.5024 28.7358C23.7279 28.7358 23.8407 28.8486 23.8407 29.1868C23.8407 29.5251 23.7279 29.6378 23.5024 29.6378C23.1642 29.6378 23.1642 29.5251 23.1642 29.1868ZM21.3602 0.323275C21.5857 0.323275 21.6985 0.436075 21.6985 0.774275C21.6985 1.11257 21.5857 1.22528 21.3602 1.22528C21.1347 1.22528 21.022 1.11257 21.022 0.774275C21.1347 0.436075 21.2475 0.323275 21.3602 0.323275ZM21.3602 1.78907C21.5857 1.78907 21.6985 1.90177 21.6985 2.23997C21.6985 2.57827 21.5857 2.69098 21.3602 2.69098C21.1347 2.69098 21.022 2.57827 21.022 2.23997C21.022 1.90177 21.2475 1.78907 21.3602 1.78907ZM21.3602 21.2945C21.5857 21.2945 21.6985 21.4072 21.6985 21.7454C21.6985 22.0837 21.5857 22.1964 21.3602 22.1964C21.1347 22.1964 21.022 22.0837 21.022 21.7454C21.022 21.4072 21.1347 21.2945 21.3602 21.2945ZM21.022 20.2797C21.022 19.9415 21.1347 19.8287 21.3602 19.8287C21.5857 19.8287 21.6985 19.9415 21.6985 20.2797C21.6985 20.618 21.5857 20.7307 21.3602 20.7307C21.1347 20.7307 21.022 20.5052 21.022 20.2797ZM21.3602 30.3143C21.5857 30.3143 21.6985 30.427 21.6985 30.7653C21.6985 31.1035 21.5857 31.2163 21.3602 31.2163C21.1347 31.2163 21.022 31.1035 21.022 30.7653C21.022 30.427 21.1347 30.3143 21.3602 30.3143ZM21.022 29.1868C21.022 28.8486 21.1347 28.7358 21.3602 28.7358C21.5857 28.7358 21.6985 28.8486 21.6985 29.1868C21.6985 29.5251 21.5857 29.6378 21.3602 29.6378C21.1347 29.6378 21.022 29.5251 21.022 29.1868ZM20.3455 10.8089C20.571 10.8089 20.6837 10.9216 20.6837 11.2599C20.6837 11.5981 20.571 11.7109 20.3455 11.7109C20.12 11.7109 20.0072 11.5981 20.0072 11.2599C20.0072 10.9216 20.12 10.8089 20.3455 10.8089ZM20.0072 9.68137C20.0072 9.34317 20.12 9.23037 20.3455 9.23037C20.571 9.23037 20.6837 9.34317 20.6837 9.68137C20.6837 10.0197 20.571 10.1324 20.3455 10.1324C20.12 10.1324 20.0072 10.0197 20.0072 9.68137ZM20.3455 12.2746C20.571 12.2746 20.6837 12.3874 20.6837 12.7256C20.6837 13.0638 20.571 13.1766 20.3455 13.1766C20.12 13.1766 20.0072 13.0638 20.0072 12.7256C20.0072 12.3874 20.12 12.2746 20.3455 12.2746ZM20.3455 24.2259C20.571 24.2259 20.6837 24.3386 20.6837 24.6769C20.6837 25.0151 20.571 25.1279 20.3455 25.1279C20.12 25.1279 20.0072 25.0151 20.0072 24.6769C20.0072 24.4514 20.12 24.2259 20.3455 24.2259ZM20.0072 23.2112C20.0072 22.8729 20.12 22.7602 20.3455 22.7602C20.571 22.7602 20.6837 22.8729 20.6837 23.2112C20.6837 23.5494 20.571 23.6622 20.3455 23.6622C20.12 23.6622 20.0072 23.5494 20.0072 23.2112ZM19.3308 0.323275C19.5563 0.323275 19.669 0.436075 19.669 0.774275C19.669 1.11257 19.5563 1.22528 19.3308 1.22528C19.1053 1.22528 18.9925 1.11257 18.9925 0.774275C18.9925 0.436075 19.1053 0.323275 19.3308 0.323275ZM19.3308 1.78907C19.5563 1.78907 19.669 1.90177 19.669 2.23997C19.669 2.57827 19.5563 2.69098 19.3308 2.69098C19.1053 2.69098 18.9925 2.57827 18.9925 2.23997C18.9925 1.90177 19.1053 1.78907 19.3308 1.78907ZM19.3308 21.2945C19.5563 21.2945 19.669 21.4072 19.669 21.7454C19.669 22.0837 19.5563 22.1964 19.3308 22.1964C19.1053 22.1964 18.9925 22.0837 18.9925 21.7454C18.9925 21.4072 19.1053 21.2945 19.3308 21.2945ZM18.9925 20.2797C18.9925 19.9415 19.1053 19.8287 19.3308 19.8287C19.5563 19.8287 19.669 19.9415 19.669 20.2797C19.669 20.618 19.5563 20.7307 19.3308 20.7307C19.1053 20.7307 18.9925 20.5052 18.9925 20.2797ZM19.218 30.3143C19.4435 30.3143 19.5563 30.427 19.5563 30.7653C19.5563 31.1035 19.4435 31.2163 19.218 31.2163C18.9925 31.2163 18.8798 31.1035 18.8798 30.7653C18.9925 30.427 19.1053 30.3143 19.218 30.3143ZM18.9925 29.1868C18.9925 28.8486 19.1053 28.7358 19.3308 28.7358C19.5563 28.7358 19.669 28.8486 19.669 29.1868C19.669 29.5251 19.5563 29.6378 19.3308 29.6378C19.1053 29.6378 18.9925 29.5251 18.9925 29.1868ZM18.2033 0.323275C18.4288 0.323275 18.5415 0.436075 18.5415 0.774275C18.5415 1.11257 18.4288 1.22528 18.2033 1.22528C17.9778 1.22528 17.865 1.11257 17.865 0.774275C17.9778 0.436075 18.0905 0.323275 18.2033 0.323275ZM16.1738 10.8089C16.3993 10.8089 16.5121 10.9216 16.5121 11.2599C16.5121 11.5981 16.3993 11.7109 16.1738 11.7109C15.9483 11.7109 15.8356 11.5981 15.8356 11.2599C15.8356 10.9216 15.9483 10.8089 16.1738 10.8089ZM15.8356 9.68137C15.8356 9.34317 15.9483 9.23037 16.1738 9.23037C16.3993 9.23037 16.5121 9.34317 16.5121 9.68137C16.5121 10.0197 16.3993 10.1324 16.1738 10.1324C15.9483 10.1324 15.8356 10.0197 15.8356 9.68137ZM16.1738 12.2746C16.3993 12.2746 16.5121 12.3874 16.5121 12.7256C16.5121 13.0638 16.3993 13.1766 16.1738 13.1766C15.9483 13.1766 15.8356 13.0638 15.8356 12.7256C15.8356 12.3874 15.9483 12.2746 16.1738 12.2746ZM16.1738 24.2259C16.3993 24.2259 16.5121 24.3386 16.5121 24.6769C16.5121 25.0151 16.3993 25.1279 16.1738 25.1279C15.9483 25.1279 15.8356 25.0151 15.8356 24.6769C15.8356 24.4514 15.9483 24.2259 16.1738 24.2259ZM15.8356 23.2112C15.8356 22.8729 15.9483 22.7602 16.1738 22.7602C16.3993 22.7602 16.5121 22.8729 16.5121 23.2112C16.5121 23.5494 16.3993 23.6622 16.1738 23.6622C15.9483 23.6622 15.8356 23.5494 15.8356 23.2112ZM15.1591 0.323275C15.3846 0.323275 15.4973 0.436075 15.4973 0.774275C15.4973 1.11257 15.3846 1.22528 15.1591 1.22528C14.9336 1.22528 14.8208 1.11257 14.8208 0.774275C14.8208 0.436075 14.9336 0.323275 15.1591 0.323275ZM15.1591 1.78907C15.3846 1.78907 15.4973 1.90177 15.4973 2.23997C15.4973 2.57827 15.3846 2.69098 15.1591 2.69098C14.9336 2.69098 14.8208 2.57827 14.8208 2.23997C14.8208 1.90177 14.9336 1.78907 15.1591 1.78907ZM15.1591 21.2945C15.3846 21.2945 15.4973 21.4072 15.4973 21.7454C15.4973 22.0837 15.3846 22.1964 15.1591 22.1964C14.9336 22.1964 14.8208 22.0837 14.8208 21.7454C14.8208 21.4072 14.9336 21.2945 15.1591 21.2945ZM14.8208 20.2797C14.8208 19.9415 14.9336 19.8287 15.1591 19.8287C15.3846 19.8287 15.4973 19.9415 15.4973 20.2797C15.4973 20.618 15.3846 20.7307 15.1591 20.7307C14.9336 20.7307 14.8208 20.5052 14.8208 20.2797ZM15.0463 30.3143C15.2718 30.3143 15.3846 30.427 15.3846 30.7653C15.3846 31.1035 15.2718 31.2163 15.0463 31.2163C14.8208 31.2163 14.7081 31.1035 14.7081 30.7653C14.8208 30.427 14.9336 30.3143 15.0463 30.3143ZM14.8208 29.1868C14.8208 28.8486 14.9336 28.7358 15.1591 28.7358C15.3846 28.7358 15.4973 28.8486 15.4973 29.1868C15.4973 29.5251 15.3846 29.6378 15.1591 29.6378C14.9336 29.6378 14.8208 29.5251 14.8208 29.1868ZM14.1444 0.323275C14.3698 0.323275 14.4826 0.436075 14.4826 0.774275C14.4826 1.11257 14.3698 1.22528 14.1444 1.22528C13.9189 1.22528 13.8061 1.11257 13.8061 0.774275C13.8061 0.436075 13.9189 0.323275 14.1444 0.323275ZM13.3551 37.1919H12.7914V37.0792H13.0169V36.4027L12.7914 36.6282L12.6786 36.5154L12.9041 36.2899H13.0169V37.0792L13.3551 37.1919ZM13.3551 35.6134H12.7914V35.5007H13.0169V34.8242L12.7914 35.0497L12.6786 34.9369L12.9041 34.7115H13.0169V35.5007L13.3551 35.6134ZM13.3551 34.1477H12.7914V34.035H13.0169V33.3585L12.7914 33.584V33.4712L13.0169 33.2457H13.1296V34.035L13.3551 34.1477ZM13.0169 31.78C13.2424 31.78 13.3551 31.8928 13.3551 32.231C13.3551 32.5692 13.2424 32.682 13.0169 32.682C12.7914 32.682 12.6786 32.5692 12.6786 32.231C12.6786 31.8928 12.7914 31.78 13.0169 31.78ZM12.7914 30.7653C12.7914 30.427 12.9041 30.3143 13.1296 30.3143C13.3551 30.3143 13.4679 30.427 13.4679 30.7653C13.4679 31.1035 13.3551 31.2163 13.1296 31.2163C12.7914 31.2163 12.7914 30.9908 12.7914 30.7653ZM13.3551 29.6378H12.7914V29.5251H13.0169V28.8486L12.7914 29.0741V28.9613L13.0169 28.7358H13.1296V29.5251L13.3551 29.6378ZM12.7914 27.7211C12.7914 27.3828 12.9041 27.2701 13.1296 27.2701C13.3551 27.2701 13.4679 27.3828 13.4679 27.7211C13.4679 28.0593 13.3551 28.1721 13.1296 28.1721C12.7914 28.1721 12.7914 28.0593 12.7914 27.7211ZM13.3551 26.7064H12.7914V26.5936H13.0169V25.9171L12.7914 26.1426L12.6786 26.0299L12.9041 25.8044H13.0169V26.5936L13.3551 26.7064ZM12.7914 24.6769C12.7914 24.3386 12.9041 24.2259 13.1296 24.2259C13.3551 24.2259 13.4679 24.3386 13.4679 24.6769C13.4679 25.0151 13.3551 25.1279 13.1296 25.1279C12.7914 25.1279 12.7914 25.0151 12.7914 24.6769ZM13.3551 23.6622H12.7914V23.5494H13.0169V22.8729L12.7914 23.0984L12.6786 22.9857L12.9041 22.7602H13.0169V23.5494L13.3551 23.6622ZM13.3551 22.1964H12.7914V22.0837H13.0169V21.4072L12.7914 21.6327L12.6786 21.5199L12.9041 21.2945H13.0169V22.0837L13.3551 22.1964ZM13.0169 19.8287C13.2424 19.8287 13.3551 19.9415 13.3551 20.2797C13.3551 20.618 13.2424 20.7307 13.0169 20.7307C12.7914 20.7307 12.6786 20.618 12.6786 20.2797C12.7914 19.9415 12.7914 19.8287 13.0169 19.8287ZM12.7914 18.7012C12.7914 18.363 12.9041 18.2503 13.1296 18.2503C13.3551 18.2503 13.4679 18.363 13.4679 18.7012C13.4679 19.0395 13.3551 19.1522 13.1296 19.1522C12.7914 19.1522 12.7914 19.0395 12.7914 18.7012ZM13.3551 17.6865H12.7914V17.5738H13.0169V16.8973L12.7914 17.1228L12.6786 17.01L12.9041 16.7845H13.0169V17.5738L13.3551 17.6865ZM12.7914 15.7698C12.7914 15.4316 12.9041 15.3188 13.1296 15.3188C13.3551 15.3188 13.4679 15.4316 13.4679 15.7698C13.4679 16.108 13.3551 16.2208 13.1296 16.2208C12.7914 16.2208 12.7914 15.9953 12.7914 15.7698ZM13.3551 14.6423H12.7914V14.5296H13.0169V13.8531L12.7914 14.0786L12.6786 13.9658L12.9041 13.7403H13.0169V14.5296L13.3551 14.6423ZM13.3551 13.1766H12.7914V13.0639H13.0169V12.3874L12.7914 12.6129L12.6786 12.5001L12.9041 12.2746H13.0169V13.0639L13.3551 13.1766ZM13.3551 11.7109H12.7914V11.5981H13.0169V10.9216L12.7914 11.1471L12.6786 11.0344L12.9041 10.8089H13.0169V11.5981L13.3551 11.7109ZM12.7914 9.68137C12.7914 9.34317 12.9041 9.23037 13.1296 9.23037C13.3551 9.23037 13.4679 9.34317 13.4679 9.68137C13.4679 10.0197 13.3551 10.1324 13.1296 10.1324C12.7914 10.1324 12.7914 10.0197 12.7914 9.68137ZM13.3551 8.66667H12.7914V8.55388H13.0169V7.87738L12.7914 8.10288L12.6786 7.99017L12.9041 7.76467H13.0169V8.55388L13.3551 8.66667ZM13.0169 6.29898C13.2424 6.29898 13.3551 6.41167 13.3551 6.74997C13.3551 7.08817 13.2424 7.20097 13.0169 7.20097C12.7914 7.20097 12.6786 7.08817 12.6786 6.74997C12.7914 6.41167 12.7914 6.29898 13.0169 6.29898ZM12.7914 5.28417C12.7914 4.94597 12.9041 4.83317 13.1296 4.83317C13.3551 4.83317 13.4679 4.94597 13.4679 5.28417C13.4679 5.62247 13.3551 5.73518 13.1296 5.73518C12.7914 5.73518 12.7914 5.50967 12.7914 5.28417ZM13.3551 4.15678H12.7914V4.04397H13.0169V3.36748L12.7914 3.59297L12.6786 3.48028L12.9041 3.25478H13.0169V4.04397L13.3551 4.15678ZM12.7914 2.23997C12.7914 1.90177 12.9041 1.78907 13.1296 1.78907C13.3551 1.78907 13.4679 1.90177 13.4679 2.23997C13.4679 2.57827 13.3551 2.69098 13.1296 2.69098C12.7914 2.69098 12.7914 2.57827 12.7914 2.23997ZM13.3551 1.22528H12.7914V1.11258H13.0169V0.436075L12.7914 0.661575L12.6786 0.548775L12.9041 0.323275H13.0169V1.11258L13.3551 1.22528ZM14.3698 37.1919H13.8061V37.0792H14.0316V36.4027L13.8061 36.6282L13.6934 36.5154L13.9189 36.2899H14.0316V37.0792L14.3698 37.1919ZM13.8061 35.1624C13.8061 34.8242 13.9189 34.7115 14.1444 34.7115C14.3698 34.7115 14.4826 34.8242 14.4826 35.1624C14.4826 35.5007 14.3698 35.6134 14.1444 35.6134C13.9189 35.6134 13.8061 35.5007 13.8061 35.1624ZM14.3698 34.1477H13.8061V34.035H14.0316V33.3585L13.8061 33.584V33.4712L14.0316 33.2457H14.1444V34.035L14.3698 34.1477ZM14.3698 32.682H13.8061V32.5692H14.0316V31.8928L13.8061 32.1183L13.6934 32.0055L13.9189 31.78H14.0316V32.5692L14.3698 32.682ZM14.3698 31.1035H13.8061V30.9908H14.0316V30.3143L13.8061 30.5398L13.6934 30.427L13.9189 30.2015H14.0316V30.9908L14.3698 31.1035ZM14.1444 28.7358C14.3698 28.7358 14.4826 28.8486 14.4826 29.1868C14.4826 29.5251 14.3698 29.6378 14.1444 29.6378C13.9189 29.6378 13.8061 29.5251 13.8061 29.1868C13.8061 28.9613 13.9189 28.7358 14.1444 28.7358ZM13.8061 27.7211C13.8061 27.3828 13.9189 27.2701 14.1444 27.2701C14.3698 27.2701 14.4826 27.3828 14.4826 27.7211C14.4826 28.0593 14.3698 28.1721 14.1444 28.1721C13.9189 28.1721 13.8061 28.0593 13.8061 27.7211ZM14.3698 26.7064H13.8061V26.5936H14.0316V25.9171L13.8061 26.1426L13.6934 26.0299L13.9189 25.8044H14.0316V26.5936L14.3698 26.7064ZM14.3698 25.1279H13.8061V25.0151H14.0316V24.3386L13.8061 24.5641V24.4514L14.0316 24.2259H14.1444V25.0151L14.3698 25.1279ZM14.3698 23.6622H13.8061V23.5494H14.0316V22.8729L13.8061 23.0984L13.6934 22.9857L13.9189 22.7602H14.0316V23.5494L14.3698 23.6622ZM14.1444 19.8287C14.3698 19.8287 14.4826 19.9415 14.4826 20.2797C14.4826 20.618 14.3698 20.7307 14.1444 20.7307C13.9189 20.7307 13.8061 20.618 13.8061 20.2797C13.8061 19.9415 13.9189 19.8287 14.1444 19.8287ZM13.8061 18.7012C13.8061 18.363 13.9189 18.2503 14.1444 18.2503C14.3698 18.2503 14.4826 18.363 14.4826 18.7012C14.4826 19.0395 14.3698 19.1522 14.1444 19.1522C13.9189 19.1522 13.8061 19.0395 13.8061 18.7012ZM14.1444 21.2945C14.3698 21.2945 14.4826 21.4072 14.4826 21.7454C14.4826 22.0837 14.3698 22.1964 14.1444 22.1964C13.9189 22.1964 13.8061 22.0837 13.8061 21.7454C13.8061 21.4072 13.9189 21.2945 14.1444 21.2945ZM14.3698 17.6865H13.8061V17.5738H14.0316V16.8973L13.8061 17.1228L13.6934 17.01L13.9189 16.7845H14.0316V17.5738L14.3698 17.6865ZM14.3698 16.2208H13.8061V16.108H14.0316V15.4316L13.8061 15.6571L13.6934 15.5443L13.9189 15.3188H14.0316V16.108L14.3698 16.2208ZM14.1444 13.7403C14.3698 13.7403 14.4826 13.8531 14.4826 14.1913C14.4826 14.5296 14.3698 14.6423 14.1444 14.6423C13.9189 14.6423 13.8061 14.5296 13.8061 14.1913C13.8061 13.9658 13.9189 13.7403 14.1444 13.7403ZM13.8061 12.7256C13.8061 12.3874 13.9189 12.2746 14.1444 12.2746C14.3698 12.2746 14.4826 12.3874 14.4826 12.7256C14.4826 13.0638 14.3698 13.1766 14.1444 13.1766C13.9189 13.1766 13.8061 13.0638 13.8061 12.7256ZM14.3698 11.7109H13.8061V11.5981H14.0316V10.9216L13.8061 11.1471L13.6934 11.0344L13.9189 10.8089H14.0316V11.5981L14.3698 11.7109ZM14.3698 10.1324H13.8061V10.0197H14.0316V9.34317L13.8061 9.56868L13.6934 9.45587L13.9189 9.23037H14.0316V10.0197L14.3698 10.1324ZM14.1444 7.76467C14.3698 7.76467 14.4826 7.87737 14.4826 8.21567C14.4826 8.55387 14.3698 8.66667 14.1444 8.66667C13.9189 8.66667 13.8061 8.55387 13.8061 8.21567C13.8061 7.99017 13.9189 7.76467 14.1444 7.76467ZM13.8061 6.74997C13.8061 6.41167 13.9189 6.29898 14.1444 6.29898C14.3698 6.29898 14.4826 6.41167 14.4826 6.74997C14.4826 7.08817 14.3698 7.20097 14.1444 7.20097C13.9189 7.20097 13.8061 6.97547 13.8061 6.74997ZM14.3698 5.62248H13.8061V5.50968H14.0316V4.83317L13.8061 5.05867L13.6934 4.94598L13.9189 4.72048H14.0316V5.50968L14.3698 5.62248ZM14.3698 4.15678H13.8061V4.04397H14.0316V3.36748L13.8061 3.59297L13.6934 3.48028L13.9189 3.25478H14.0316V4.04397L14.3698 4.15678ZM14.3698 2.69098H13.8061V2.57827H14.0316V1.90178L13.8061 2.12728L13.6934 2.01458L13.9189 1.78907H14.0316V2.57827L14.3698 2.69098ZM15.3846 37.1919H14.8208V37.0792H15.0463V36.4027L14.8208 36.6282L14.7081 36.5154L14.9336 36.2899H15.0463V37.0792L15.3846 37.1919ZM15.0463 34.7115C15.2718 34.7115 15.3846 34.8242 15.3846 35.1624C15.3846 35.5007 15.2718 35.6134 15.0463 35.6134C14.8208 35.6134 14.7081 35.5007 14.7081 35.1624C14.8208 34.937 14.9336 34.7115 15.0463 34.7115ZM14.8208 33.6967C14.8208 33.3585 14.9336 33.2457 15.1591 33.2457C15.3846 33.2457 15.4973 33.3585 15.4973 33.6967C15.4973 34.035 15.3846 34.1477 15.1591 34.1477C14.9336 34.1477 14.8208 34.035 14.8208 33.6967ZM15.3846 32.682H14.8208V32.5692H15.0463V31.8928L14.8208 32.1183L14.7081 32.0055L14.9336 31.78H15.0463V32.5692L15.3846 32.682ZM15.3846 28.1721H14.8208V28.0593H15.0463V27.3828L14.8208 27.6083L14.7081 27.4956L14.9336 27.2701H15.0463V28.0593L15.3846 28.1721ZM15.4973 26.7064H14.9336V26.5936H15.1591V25.9171L14.9336 26.1426L14.8208 26.0299L15.0463 25.8044H15.1591V26.5936L15.4973 26.7064ZM14.8208 24.6769C14.8208 24.3386 14.9336 24.2259 15.1591 24.2259C15.3846 24.2259 15.4973 24.3386 15.4973 24.6769C15.4973 25.0151 15.3846 25.1279 15.1591 25.1279C14.9336 25.1279 14.8208 25.0151 14.8208 24.6769ZM15.4973 23.6622H14.9336V23.5494H15.1591V22.8729L14.9336 23.0984L14.8208 22.9857L15.0463 22.7602H15.1591V23.5494L15.4973 23.6622ZM15.4973 19.1522H14.9336V19.0395H15.1591V18.363L14.9336 18.5885L14.8208 18.4758L15.0463 18.2503H15.1591V19.0395L15.4973 19.1522ZM15.4973 17.6865H14.9336V17.5738H15.1591V16.8973L14.9336 17.1228L14.8208 17.01L15.0463 16.7845H15.1591V17.5738L15.4973 17.6865ZM14.8208 15.7698C14.8208 15.4316 14.9336 15.3188 15.1591 15.3188C15.3846 15.3188 15.4973 15.4316 15.4973 15.7698C15.4973 16.108 15.3846 16.2208 15.1591 16.2208C14.9336 16.2208 14.8208 15.9953 14.8208 15.7698ZM15.4973 14.6423H14.9336V14.5296H15.1591V13.8531L14.9336 14.0786L14.8208 13.9658L15.0463 13.7403H15.1591V14.5296L15.4973 14.6423ZM15.4973 13.1766H14.9336V13.0639H15.1591V12.3874L14.9336 12.6129L14.8208 12.5001L15.0463 12.2746H15.1591V13.0639L15.4973 13.1766ZM14.8208 11.2599C14.8208 10.9216 14.9336 10.8089 15.1591 10.8089C15.3846 10.8089 15.4973 10.9216 15.4973 11.2599C15.4973 11.5981 15.3846 11.7109 15.1591 11.7109C14.9336 11.7109 14.8208 11.4854 14.8208 11.2599ZM15.4973 10.1324H14.9336V10.0197H15.1591V9.34317L14.9336 9.56868L14.8208 9.45587L15.0463 9.23037H15.1591V10.0197L15.4973 10.1324ZM15.4973 8.66667H14.9336V8.55388H15.1591V7.87738L14.9336 8.10288L14.8208 7.99017L15.0463 7.76467H15.1591V8.55388L15.4973 8.66667ZM15.4973 7.20097H14.9336V7.08818H15.1591V6.41168L14.9336 6.63718L14.8208 6.52447L15.0463 6.29898H15.1591V7.08818L15.4973 7.20097ZM14.8208 5.28417C14.8208 4.94597 14.9336 4.83317 15.1591 4.83317C15.3846 4.83317 15.4973 4.94597 15.4973 5.28417C15.4973 5.62247 15.3846 5.73518 15.1591 5.73518C14.9336 5.73518 14.8208 5.50967 14.8208 5.28417ZM15.4973 4.15678H14.9336V4.04397H15.1591V3.36748L14.9336 3.59297L14.8208 3.48028L15.0463 3.25478H15.1591V4.04397L15.4973 4.15678ZM16.1738 37.1919C15.9483 37.1919 15.8356 37.0792 15.8356 36.7409C15.8356 36.4027 15.9483 36.2899 16.1738 36.2899C16.3993 36.2899 16.5121 36.4027 16.5121 36.7409C16.3993 36.9664 16.3993 37.1919 16.1738 37.1919ZM16.5121 35.6134H15.9483V35.5007H16.1738V34.8242L15.9483 35.0497L15.8356 34.9369L16.0611 34.7115H16.1738V35.5007L16.5121 35.6134ZM16.1738 33.2457C16.3993 33.2457 16.5121 33.3585 16.5121 33.6967C16.5121 34.035 16.3993 34.1477 16.1738 34.1477C15.9483 34.1477 15.8356 34.035 15.8356 33.6967C15.8356 33.3585 15.9483 33.2457 16.1738 33.2457ZM15.8356 32.231C15.8356 31.8928 15.9483 31.78 16.1738 31.78C16.3993 31.78 16.5121 31.8928 16.5121 32.231C16.5121 32.5692 16.3993 32.682 16.1738 32.682C15.9483 32.682 15.8356 32.4565 15.8356 32.231ZM16.5121 31.1035H15.9483V30.9908H16.1738V30.3143L15.9483 30.5398L15.8356 30.427L16.0611 30.2015H16.1738V30.9908L16.5121 31.1035ZM15.8356 29.1868C15.8356 28.8486 15.9483 28.7358 16.1738 28.7358C16.3993 28.7358 16.5121 28.8486 16.5121 29.1868C16.5121 29.5251 16.3993 29.6378 16.1738 29.6378C15.9483 29.6378 15.8356 29.5251 15.8356 29.1868ZM16.1738 28.1721C15.9483 28.1721 15.8356 28.0593 15.8356 27.7211C15.8356 27.3828 15.9483 27.2701 16.1738 27.2701C16.3993 27.2701 16.5121 27.3828 16.5121 27.7211C16.5121 28.0593 16.3993 28.1721 16.1738 28.1721ZM16.5121 26.7064H15.9483V26.5936H16.1738V25.9171L15.9483 26.1426L15.8356 26.0299L16.0611 25.8044H16.1738V26.5936L16.5121 26.7064ZM16.5121 22.1964H15.9483V22.0837H16.1738V21.4072L15.9483 21.6327L15.8356 21.5199L16.0611 21.2945H16.1738V22.0837L16.5121 22.1964ZM15.8356 20.2797C15.8356 19.9415 15.9483 19.8287 16.1738 19.8287C16.3993 19.8287 16.5121 19.9415 16.5121 20.2797C16.5121 20.618 16.3993 20.7307 16.1738 20.7307C15.9483 20.7307 15.8356 20.5052 15.8356 20.2797ZM16.5121 19.1522H15.9483V19.0395H16.1738V18.363L15.9483 18.5885L15.8356 18.4758L16.0611 18.2503H16.1738V19.0395L16.5121 19.1522ZM15.8356 17.2355C15.8356 16.8973 15.9483 16.7845 16.1738 16.7845C16.3993 16.7845 16.5121 16.8973 16.5121 17.2355C16.5121 17.5738 16.3993 17.6865 16.1738 17.6865C15.9483 17.6865 15.8356 17.461 15.8356 17.2355ZM16.5121 16.108H15.9483V15.9953H16.1738V15.3188L15.9483 15.5443L15.8356 15.4316L16.0611 15.2061H16.1738V15.9953L16.5121 16.108ZM16.5121 14.6423H15.9483V14.5296H16.1738V13.8531L15.9483 14.0786L15.8356 13.9658L16.0611 13.7403H16.1738V14.5296L16.5121 14.6423ZM16.5121 8.66667H15.9483V8.55388H16.1738V7.87738L15.9483 8.10288L15.8356 7.99017L16.0611 7.76467H16.1738V8.55388L16.5121 8.66667ZM15.8356 6.74997C15.8356 6.41167 15.9483 6.29898 16.1738 6.29898C16.3993 6.29898 16.5121 6.41167 16.5121 6.74997C16.5121 7.08817 16.3993 7.20097 16.1738 7.20097C15.9483 7.20097 15.8356 6.97547 15.8356 6.74997ZM16.5121 5.62248H15.9483V5.50968H16.1738V4.83317L15.9483 5.05867L15.8356 4.94598L16.0611 4.72048H16.1738V5.50968L16.5121 5.62248ZM15.9483 3.70578C15.9483 3.36748 16.0611 3.25478 16.2866 3.25478C16.5121 3.25478 16.6248 3.36748 16.6248 3.70578C16.6248 4.04398 16.5121 4.15678 16.2866 4.15678C15.9483 4.15678 15.9483 4.04398 15.9483 3.70578ZM16.5121 2.69098H15.9483V2.57827H16.1738V1.90178L15.9483 2.12728L15.8356 2.01458L16.0611 1.78907H16.1738V2.57827L16.5121 2.69098ZM16.5121 1.22528H15.9483V1.11258H16.1738V0.436075L15.9483 0.661575L15.8356 0.548775L16.0611 0.323275H16.1738V1.11258L16.5121 1.22528ZM17.5268 37.1919H16.963V37.0792H17.1885V36.4027L16.963 36.6282L16.8503 36.5154L17.0758 36.2899H17.1885V37.0792L17.5268 37.1919ZM17.5268 35.6134H16.963V35.5007H17.1885V34.8242L16.963 35.0497L16.8503 34.9369L17.0758 34.7115H17.1885V35.5007L17.5268 35.6134ZM17.5268 34.1477H16.963V34.035H17.1885V33.3585L16.963 33.584L16.8503 33.4712L17.0758 33.2457H17.1885V34.035L17.5268 34.1477ZM17.1885 31.78C17.414 31.78 17.5268 31.8928 17.5268 32.231C17.5268 32.5692 17.414 32.682 17.1885 32.682C16.963 32.682 16.8503 32.5692 16.8503 32.231C16.8503 31.8928 16.963 31.78 17.1885 31.78ZM16.963 30.7653C16.963 30.427 17.0758 30.3143 17.3013 30.3143C17.5268 30.3143 17.6395 30.427 17.6395 30.7653C17.6395 31.1035 17.5268 31.2163 17.3013 31.2163C16.963 31.2163 16.963 30.9908 16.963 30.7653ZM17.5268 29.6378H16.963V29.5251H17.1885V28.8486L16.963 29.0741L16.8503 28.9613L17.0758 28.7358H17.1885V29.5251L17.5268 29.6378ZM16.963 27.7211C16.963 27.3828 17.0758 27.2701 17.3013 27.2701C17.5268 27.2701 17.6395 27.3828 17.6395 27.7211C17.6395 28.0593 17.5268 28.1721 17.3013 28.1721C16.963 28.1721 16.963 28.0593 16.963 27.7211ZM17.5268 26.7064H16.963V26.5936H17.1885V25.9171L16.963 26.1426L16.8503 26.0299L17.0758 25.8044H17.1885V26.5936L17.5268 26.7064ZM16.963 24.6769C16.963 24.3386 17.0758 24.2259 17.3013 24.2259C17.5268 24.2259 17.6395 24.3386 17.6395 24.6769C17.6395 25.0151 17.5268 25.1279 17.3013 25.1279C16.963 25.1279 16.963 25.0151 16.963 24.6769ZM17.5268 23.6622H16.963V23.5494H17.1885V22.8729L16.963 23.0984L16.8503 22.9857L17.0758 22.7602H17.1885V23.5494L17.5268 23.6622ZM17.5268 22.1964H16.963V22.0837H17.1885V21.4072L16.963 21.6327L16.8503 21.5199L17.0758 21.2945H17.1885V22.0837L17.5268 22.1964ZM17.1885 19.8287C17.414 19.8287 17.5268 19.9415 17.5268 20.2797C17.5268 20.618 17.414 20.7307 17.1885 20.7307C16.963 20.7307 16.8503 20.618 16.8503 20.2797C16.9631 19.9415 16.963 19.8287 17.1885 19.8287ZM16.963 18.7012C16.963 18.363 17.0758 18.2503 17.3013 18.2503C17.5268 18.2503 17.6395 18.363 17.6395 18.7012C17.6395 19.0395 17.5268 19.1522 17.3013 19.1522C16.963 19.1522 16.963 19.0395 16.963 18.7012ZM17.5268 17.6865H16.963V17.5738H17.1885V16.8973L16.963 17.1228L16.8503 17.01L17.0758 16.7845H17.1885V17.5738L17.5268 17.6865ZM16.963 15.7698C16.963 15.4316 17.0758 15.3188 17.3013 15.3188C17.5268 15.3188 17.6395 15.4316 17.6395 15.7698C17.6395 16.108 17.5268 16.2208 17.3013 16.2208C16.963 16.2208 16.963 15.9953 16.963 15.7698ZM17.5268 14.6423H16.963V14.5296H17.1885V13.8531L16.963 14.0786L16.8503 13.9658L17.0758 13.7403H17.1885V14.5296L17.5268 14.6423ZM17.5268 13.1766H16.963V13.0639H17.1885V12.3874L16.963 12.6129L16.8503 12.5001L17.0758 12.2746H17.1885V13.0639L17.5268 13.1766ZM17.5268 11.7109H16.963V11.5981H17.1885V10.9216L16.963 11.1471L16.8503 11.0344L17.0758 10.8089H17.1885V11.5981L17.5268 11.7109ZM16.963 9.68137C16.963 9.34317 17.0758 9.23037 17.3013 9.23037C17.5268 9.23037 17.6395 9.34317 17.6395 9.68137C17.6395 10.0197 17.5268 10.1324 17.3013 10.1324C16.963 10.1324 16.963 10.0197 16.963 9.68137ZM17.5268 8.66667H16.963V8.55388H17.1885V7.87738L16.963 8.10288L16.8503 7.99017L17.0758 7.76467H17.1885V8.55388L17.5268 8.66667ZM17.1885 6.29898C17.414 6.29898 17.5268 6.41167 17.5268 6.74997C17.5268 7.08817 17.414 7.20097 17.1885 7.20097C16.963 7.20097 16.8503 7.08817 16.8503 6.74997C16.9631 6.41167 16.963 6.29898 17.1885 6.29898ZM16.963 5.28417C16.963 4.94597 17.0758 4.83317 17.3013 4.83317C17.5268 4.83317 17.6395 4.94597 17.6395 5.28417C17.6395 5.62247 17.5268 5.73518 17.3013 5.73518C16.963 5.73518 16.963 5.50967 16.963 5.28417ZM17.5268 4.15678H16.963V4.04397H17.1885V3.36748L16.963 3.59297L16.8503 3.48028L17.0758 3.25478H17.1885V4.04397L17.5268 4.15678ZM16.963 2.23997C16.963 1.90177 17.0758 1.78907 17.3013 1.78907C17.5268 1.78907 17.6395 1.90177 17.6395 2.23997C17.6395 2.57827 17.5268 2.69098 17.3013 2.69098C16.963 2.69098 16.963 2.57827 16.963 2.23997ZM17.5268 1.22528H16.963V1.11258H17.1885V0.436075L16.963 0.661575L16.8503 0.548775L17.0758 0.323275H17.1885V1.11258L17.5268 1.22528ZM18.5415 37.1919H17.9778V37.0792H18.2033V36.4027L17.9778 36.6282L17.865 36.5154L18.0905 36.2899H18.2033V37.0792L18.5415 37.1919ZM17.9778 35.1624C17.9778 34.8242 18.0905 34.7115 18.316 34.7115C18.5415 34.7115 18.6543 34.8242 18.6543 35.1624C18.6543 35.5007 18.5415 35.6134 18.316 35.6134C18.0905 35.6134 17.9778 35.5007 17.9778 35.1624ZM18.5415 34.1477H17.9778V34.035H18.2033V33.3585L17.9778 33.584V33.4712L18.2033 33.2457H18.316V34.035L18.5415 34.1477ZM18.5415 32.682H17.9778V32.5692H18.2033V31.8928L17.9778 32.1183L17.865 32.0055L18.0905 31.78H18.2033V32.5692L18.5415 32.682ZM18.5415 31.1035H17.9778V30.9908H18.2033V30.3143L17.9778 30.5398L17.865 30.427L18.0905 30.2015H18.2033V30.9908L18.5415 31.1035ZM18.2033 28.7358C18.4288 28.7358 18.5415 28.8486 18.5415 29.1868C18.5415 29.5251 18.4288 29.6378 18.2033 29.6378C17.9778 29.6378 17.865 29.5251 17.865 29.1868C17.9778 28.9613 18.0905 28.7358 18.2033 28.7358ZM17.9778 27.7211C17.9778 27.3828 18.0905 27.2701 18.316 27.2701C18.5415 27.2701 18.6543 27.3828 18.6543 27.7211C18.6543 28.0593 18.5415 28.1721 18.316 28.1721C18.0905 28.1721 17.9778 28.0593 17.9778 27.7211ZM18.5415 26.7064H17.9778V26.5936H18.2033V25.9171L17.9778 26.1426L17.865 26.0299L18.0905 25.8044H18.2033V26.5936L18.5415 26.7064ZM18.5415 25.1279H17.9778V25.0151H18.2033V24.3386L17.9778 24.5641V24.4514L18.2033 24.2259H18.316V25.0151L18.5415 25.1279ZM18.5415 23.6622H17.9778V23.5494H18.2033V22.8729L17.9778 23.0984L17.865 22.9857L18.0905 22.7602H18.2033V23.5494L18.5415 23.6622ZM18.2033 19.8287C18.4288 19.8287 18.5415 19.9415 18.5415 20.2797C18.5415 20.618 18.4288 20.7307 18.2033 20.7307C17.9778 20.7307 17.865 20.618 17.865 20.2797C17.9778 19.9415 18.0905 19.8287 18.2033 19.8287ZM17.9778 18.7012C17.9778 18.363 18.0905 18.2503 18.316 18.2503C18.5415 18.2503 18.6543 18.363 18.6543 18.7012C18.6543 19.0395 18.5415 19.1522 18.316 19.1522C18.0905 19.1522 17.9778 19.0395 17.9778 18.7012ZM18.2033 21.2945C18.4288 21.2945 18.5415 21.4072 18.5415 21.7454C18.5415 22.0837 18.4288 22.1964 18.2033 22.1964C17.9778 22.1964 17.865 22.0837 17.865 21.7454C17.9778 21.4072 18.0905 21.2945 18.2033 21.2945ZM18.5415 17.6865H17.9778V17.5738H18.2033V16.8973L17.9778 17.1228L17.865 17.01L18.0905 16.7845H18.2033V17.5738L18.5415 17.6865ZM18.5415 16.2208H17.9778V16.108H18.2033V15.4316L17.9778 15.6571L17.865 15.5443L18.0905 15.3188H18.2033V16.108L18.5415 16.2208ZM18.2033 13.7403C18.4288 13.7403 18.5415 13.8531 18.5415 14.1913C18.5415 14.5296 18.4288 14.6423 18.2033 14.6423C17.9778 14.6423 17.865 14.5296 17.865 14.1913C17.9778 13.9658 18.0905 13.7403 18.2033 13.7403ZM17.9778 12.7256C17.9778 12.3874 18.0905 12.2746 18.316 12.2746C18.5415 12.2746 18.6543 12.3874 18.6543 12.7256C18.6543 13.0638 18.5415 13.1766 18.316 13.1766C18.0905 13.1766 17.9778 13.0638 17.9778 12.7256ZM18.5415 11.7109H17.9778V11.5981H18.2033V10.9216L17.9778 11.1471L17.865 11.0344L18.0905 10.8089H18.2033V11.5981L18.5415 11.7109ZM18.5415 10.1324H17.9778V10.0197H18.2033V9.34317L17.9778 9.56868L17.865 9.45587L18.0905 9.23037H18.2033V10.0197L18.5415 10.1324ZM18.2033 7.76467C18.4288 7.76467 18.5415 7.87737 18.5415 8.21567C18.5415 8.55387 18.4288 8.66667 18.2033 8.66667C17.9778 8.66667 17.865 8.55387 17.865 8.21567C17.9778 7.99017 18.0905 7.76467 18.2033 7.76467ZM17.9778 6.74997C17.9778 6.41167 18.0905 6.29898 18.316 6.29898C18.5415 6.29898 18.6543 6.41167 18.6543 6.74997C18.6543 7.08817 18.5415 7.20097 18.316 7.20097C18.0905 7.20097 17.9778 6.97547 17.9778 6.74997ZM18.5415 5.62248H17.9778V5.50968H18.2033V4.83317L17.9778 5.05867L17.865 4.94598L18.0905 4.72048H18.2033V5.50968L18.5415 5.62248ZM18.5415 4.15678H17.9778V4.04397H18.2033V3.36748L17.9778 3.59297L17.865 3.48028L18.0905 3.25478H18.2033V4.04397L18.5415 4.15678ZM18.5415 2.69098H17.9778V2.57827H18.2033V1.90178L17.9778 2.12728L17.865 2.01458L18.0905 1.78907H18.2033V2.57827L18.5415 2.69098ZM19.5563 37.1919H18.9925V37.0792H19.218V36.4027L18.9925 36.6282L18.8798 36.5154L19.1053 36.2899H19.218V37.0792L19.5563 37.1919ZM19.218 34.7115C19.4435 34.7115 19.5563 34.8242 19.5563 35.1624C19.5563 35.5007 19.4435 35.6134 19.218 35.6134C18.9925 35.6134 18.8798 35.5007 18.8798 35.1624C18.9925 34.937 19.1053 34.7115 19.218 34.7115ZM18.9925 33.6967C18.9925 33.3585 19.1053 33.2457 19.3308 33.2457C19.5563 33.2457 19.669 33.3585 19.669 33.6967C19.669 34.035 19.5563 34.1477 19.3308 34.1477C19.1053 34.1477 18.9925 34.035 18.9925 33.6967ZM19.5563 32.682H18.9925V32.5692H19.218V31.8928L18.9925 32.1183L18.8798 32.0055L19.1053 31.78H19.218V32.5692L19.5563 32.682ZM19.5563 28.1721H18.9925V28.0593H19.218V27.3828L18.9925 27.6083L18.8798 27.4956L19.1053 27.2701H19.218V28.0593L19.5563 28.1721ZM19.5563 26.7064H18.9925V26.5936H19.218V25.9171L18.9925 26.1426L18.8798 26.0299L19.1053 25.8044H19.218V26.5936L19.5563 26.7064ZM18.9925 24.6769C18.9925 24.3386 19.1053 24.2259 19.3308 24.2259C19.5563 24.2259 19.669 24.3386 19.669 24.6769C19.669 25.0151 19.5563 25.1279 19.3308 25.1279C19.1053 25.1279 18.9925 25.0151 18.9925 24.6769ZM19.5563 23.6622H18.9925V23.5494H19.218V22.8729L18.9925 23.0984L18.8798 22.9857L19.1053 22.7602H19.218V23.5494L19.5563 23.6622ZM19.669 19.1522H19.1053V19.0395H19.3308V18.363L19.1053 18.5885L18.9925 18.4758L19.218 18.2503H19.3308V19.0395L19.669 19.1522ZM19.669 17.6865H19.1053V17.5738H19.3308V16.8973L19.1053 17.1228L18.9925 17.01L19.218 16.7845H19.3308V17.5738L19.669 17.6865ZM18.9925 15.7698C18.9925 15.4316 19.1053 15.3188 19.3308 15.3188C19.5563 15.3188 19.669 15.4316 19.669 15.7698C19.669 16.108 19.5563 16.2208 19.3308 16.2208C19.1053 16.2208 18.9925 15.9953 18.9925 15.7698ZM19.669 14.6423H19.1053V14.5296H19.3308V13.8531L19.1053 14.0786L18.9925 13.9658L19.218 13.7403H19.3308V14.5296L19.669 14.6423ZM19.669 13.1766H19.1053V13.0639H19.3308V12.3874L19.1053 12.6129L18.9925 12.5001L19.218 12.2746H19.3308V13.0639L19.669 13.1766ZM18.9925 11.2599C18.9925 10.9216 19.1053 10.8089 19.3308 10.8089C19.5563 10.8089 19.669 10.9216 19.669 11.2599C19.669 11.5981 19.5563 11.7109 19.3308 11.7109C19.1053 11.7109 18.9925 11.4854 18.9925 11.2599ZM19.669 10.1324H19.1053V10.0197H19.3308V9.34317L19.1053 9.56868L18.9925 9.45587L19.218 9.23037H19.3308V10.0197L19.669 10.1324ZM19.669 8.66667H19.1053V8.55388H19.3308V7.87738L19.1053 8.10288L18.9925 7.99017L19.218 7.76467H19.3308V8.55388L19.669 8.66667ZM19.669 7.20097H19.1053V7.08818H19.3308V6.41168L19.1053 6.63718L18.9925 6.52447L19.218 6.29898H19.3308V7.08818L19.669 7.20097ZM18.9925 5.28417C18.9925 4.94597 19.1053 4.83317 19.3308 4.83317C19.5563 4.83317 19.669 4.94597 19.669 5.28417C19.669 5.62247 19.5563 5.73518 19.3308 5.73518C19.1053 5.73518 18.9925 5.50967 18.9925 5.28417ZM19.669 4.15678H19.1053V4.04397H19.3308V3.36748L19.1053 3.59297L18.9925 3.48028L19.218 3.25478H19.3308V4.04397L19.669 4.15678ZM20.3455 37.1919C20.12 37.1919 20.0072 37.0792 20.0072 36.7409C20.0072 36.4027 20.12 36.2899 20.3455 36.2899C20.571 36.2899 20.6837 36.4027 20.6837 36.7409C20.571 36.9664 20.571 37.1919 20.3455 37.1919ZM20.571 35.6134H20.0072V35.5007H20.2327V34.8242H20.3455V35.6134H20.571ZM20.3455 33.2457C20.571 33.2457 20.6837 33.3585 20.6837 33.6967C20.6837 34.035 20.571 34.1477 20.3455 34.1477C20.12 34.1477 20.0072 34.035 20.0072 33.6967C20.0072 33.3585 20.12 33.2457 20.3455 33.2457ZM20.0072 32.231C20.0072 31.8928 20.12 31.78 20.3455 31.78C20.571 31.78 20.6837 31.8928 20.6837 32.231C20.6837 32.5692 20.571 32.682 20.3455 32.682C20.12 32.682 20.0072 32.4565 20.0072 32.231ZM20.571 31.1035H20.0072V30.9908H20.2327V30.3143H20.3455V31.1035H20.571ZM20.0072 29.1868C20.0072 28.8486 20.12 28.7358 20.3455 28.7358C20.571 28.7358 20.6837 28.8486 20.6837 29.1868C20.6837 29.5251 20.571 29.6378 20.3455 29.6378C20.12 29.6378 20.0072 29.5251 20.0072 29.1868ZM20.3455 28.1721C20.12 28.1721 20.0072 28.0593 20.0072 27.7211C20.0072 27.3828 20.12 27.2701 20.3455 27.2701C20.571 27.2701 20.6837 27.3828 20.6837 27.7211C20.6837 28.0593 20.571 28.1721 20.3455 28.1721ZM20.6837 26.7064H20.0072V26.5936H20.2327V25.9171L20.0072 26.1426V26.0299L20.2327 25.8044H20.3455V26.5936L20.6837 26.7064ZM20.6837 22.1964H20.12V22.0837H20.3455V21.4072L20.12 21.6327L20.0072 21.5199L20.2327 21.2945H20.3455V22.0837L20.6837 22.1964ZM20.0072 20.2797C20.0072 19.9415 20.12 19.8287 20.3455 19.8287C20.571 19.8287 20.6837 19.9415 20.6837 20.2797C20.6837 20.618 20.571 20.7307 20.3455 20.7307C20.12 20.7307 20.0072 20.5052 20.0072 20.2797ZM20.6837 19.1522H20.12V19.0395H20.3455V18.363L20.12 18.5885L20.0072 18.4758L20.2327 18.2503H20.3455V19.0395L20.6837 19.1522ZM20.0072 17.2355C20.0072 16.8973 20.12 16.7845 20.3455 16.7845C20.571 16.7845 20.6837 16.8973 20.6837 17.2355C20.6837 17.5738 20.571 17.6865 20.3455 17.6865C20.12 17.6865 20.0072 17.461 20.0072 17.2355ZM20.6837 16.108H20.12V15.9953H20.3455V15.3188L20.12 15.5443H20.0072L20.2327 15.3188H20.3455V16.108H20.6837ZM20.6837 14.6423H20.12V14.5296H20.3455V13.8531L20.12 14.0786L20.0072 13.9658L20.2327 13.7403H20.3455V14.5296L20.6837 14.6423ZM20.6837 8.66667H20.12V8.55388H20.3455V7.87738L20.12 8.10288L20.0072 7.99017L20.2327 7.76467H20.3455V8.55388L20.6837 8.66667ZM20.0072 6.74997C20.0072 6.41167 20.12 6.29898 20.3455 6.29898C20.571 6.29898 20.6837 6.41167 20.6837 6.74997C20.6837 7.08817 20.571 7.20097 20.3455 7.20097C20.12 7.20097 20.0072 6.97547 20.0072 6.74997ZM20.6837 5.62248H20.12V5.50968H20.3455V4.83317L20.12 5.05867H20.0072L20.2327 4.83317H20.3455V5.62248H20.6837ZM20.0072 3.70578C20.0072 3.36748 20.12 3.25478 20.3455 3.25478C20.571 3.25478 20.6837 3.36748 20.6837 3.70578C20.6837 4.04398 20.571 4.15678 20.3455 4.15678C20.12 4.15678 20.0072 4.04398 20.0072 3.70578ZM20.6837 2.69098H20.12V2.57827H20.3455V1.90178L20.12 2.12728L20.0072 2.01458L20.2327 1.78907H20.3455V2.57827L20.6837 2.69098ZM20.6837 1.22528H20.12V1.11258H20.3455V0.436075L20.12 0.661575L20.0072 0.548775L20.2327 0.323275H20.3455V1.11258L20.6837 1.22528ZM21.6985 37.1919H21.1347V37.0792H21.3602V36.4027L21.1347 36.5154L21.022 36.4027L21.2475 36.1772H21.3602V36.9664L21.6985 37.1919ZM21.3602 34.7115C21.5857 34.7115 21.6985 34.8242 21.6985 35.1624C21.6985 35.5007 21.5857 35.6134 21.3602 35.6134C21.1347 35.6134 21.022 35.5007 21.022 35.1624C21.022 34.937 21.1347 34.7115 21.3602 34.7115ZM21.022 33.6967C21.022 33.3585 21.1347 33.2457 21.3602 33.2457C21.5857 33.2457 21.6985 33.3585 21.6985 33.6967C21.6985 34.035 21.5857 34.1477 21.3602 34.1477C21.1347 34.1477 21.022 34.035 21.022 33.6967ZM21.6985 32.682H21.1347V32.5692H21.3602V31.8928L21.1347 32.1183L21.022 32.0055L21.2475 31.78H21.3602V32.5692L21.6985 32.682ZM21.6985 28.1721H21.1347V28.0593H21.3602V27.3828L21.1347 27.6083L21.022 27.4956L21.2475 27.2701H21.3602V28.0593L21.6985 28.1721ZM21.6985 26.7064H21.1347V26.5936H21.3602V25.9171L21.1347 26.0299L21.022 25.9171L21.2475 25.6916H21.3602V26.4809L21.6985 26.7064ZM21.022 24.6769C21.022 24.3386 21.1347 24.2259 21.3602 24.2259C21.5857 24.2259 21.6985 24.3386 21.6985 24.6769C21.6985 25.0151 21.5857 25.1279 21.3602 25.1279C21.1347 25.1279 21.022 25.0151 21.022 24.6769ZM21.6985 23.6622H21.1347V23.5494H21.3602V22.8729L21.1347 23.0984L21.022 22.9857L21.2475 22.7602H21.3602V23.5494L21.6985 23.6622ZM21.6985 19.1522H21.1347V19.0395H21.3602V18.363L21.1347 18.5885L21.022 18.4758L21.2475 18.2503H21.3602V19.0395L21.6985 19.1522ZM21.6985 17.6865H21.1347V17.5738H21.3602V16.8973L21.1347 17.1228L21.022 17.01L21.2475 16.7845H21.3602V17.5738L21.6985 17.6865ZM21.1347 15.7698C21.1347 15.4316 21.2475 15.3188 21.473 15.3188C21.6985 15.3188 21.8112 15.4316 21.8112 15.7698C21.8112 16.108 21.6985 16.2208 21.473 16.2208C21.1347 16.2208 21.1347 15.9953 21.1347 15.7698ZM21.6985 14.6423H21.1347V14.5296H21.3602V13.8531L21.1347 14.0786V13.9658L21.3602 13.7403H21.473V14.5296L21.6985 14.6423ZM21.6985 13.1766H21.1347V13.0639H21.3602V12.3874L21.1347 12.6129V12.5001L21.3602 12.2746H21.473V13.0639L21.6985 13.1766ZM21.1347 11.2599C21.1347 10.9216 21.2475 10.8089 21.473 10.8089C21.6985 10.8089 21.8112 10.9216 21.8112 11.2599C21.8112 11.5981 21.6985 11.7109 21.473 11.7109C21.1347 11.7109 21.1347 11.4854 21.1347 11.2599ZM21.6985 10.1324H21.1347V10.0197H21.3602V9.34317L21.1347 9.56868V9.45587L21.3602 9.23037H21.473V10.0197L21.6985 10.1324ZM21.6985 8.66667H21.1347V8.55388H21.3602V7.87738L21.1347 8.10288V7.99017L21.3602 7.76467H21.473V8.55388L21.6985 8.66667ZM21.6985 7.20097H21.1347V7.08818H21.3602V6.41168L21.1347 6.52447L21.3602 6.29898H21.473V7.08818L21.6985 7.20097ZM21.1347 5.28417C21.1347 4.94597 21.2475 4.83317 21.473 4.83317C21.6985 4.83317 21.8112 4.94597 21.8112 5.28417C21.8112 5.62247 21.6985 5.73518 21.473 5.73518C21.1347 5.73518 21.1347 5.50967 21.1347 5.28417ZM21.6985 4.15678H21.1347V4.04397H21.3602V3.36748L21.1347 3.59297V3.48028L21.3602 3.25478H21.473V4.04397L21.6985 4.15678ZM22.7132 37.1919H22.1495V37.0792H22.3749V36.4027L22.1495 36.6282L22.0367 36.5154L22.2622 36.2899H22.3749V37.0792L22.7132 37.1919ZM22.7132 35.6134H22.1495V35.5007H22.3749V34.8242L22.1495 35.0497L22.0367 34.9369L22.2622 34.7115H22.3749V35.5007L22.7132 35.6134ZM22.7132 34.1477H22.1495V34.035H22.3749V33.3585L22.1495 33.584V33.4712L22.3749 33.2457H22.4877V34.035L22.7132 34.1477ZM22.3749 31.78C22.6004 31.78 22.7132 31.8928 22.7132 32.231C22.7132 32.5692 22.6004 32.682 22.3749 32.682C22.1495 32.682 22.0367 32.5692 22.0367 32.231C22.0367 31.8928 22.2622 31.78 22.3749 31.78ZM22.1495 30.7653C22.1495 30.427 22.2622 30.3143 22.4877 30.3143C22.7132 30.3143 22.8259 30.427 22.8259 30.7653C22.8259 31.1035 22.7132 31.2163 22.4877 31.2163C22.2622 31.2163 22.1495 30.9908 22.1495 30.7653ZM22.7132 29.6378H22.1495V29.5251H22.3749V28.8486L22.1495 29.0741V28.9613L22.3749 28.7358H22.4877V29.5251L22.7132 29.6378ZM22.1495 27.7211C22.1495 27.3828 22.2622 27.2701 22.4877 27.2701C22.7132 27.2701 22.8259 27.3828 22.8259 27.7211C22.8259 28.0593 22.7132 28.1721 22.4877 28.1721C22.2622 28.1721 22.1495 28.0593 22.1495 27.7211ZM22.7132 26.7064H22.1495V26.5936H22.3749V25.9171L22.1495 26.1426L22.0367 26.0299L22.2622 25.8044H22.3749V26.5936L22.7132 26.7064ZM22.1495 24.6769C22.1495 24.3386 22.2622 24.2259 22.4877 24.2259C22.7132 24.2259 22.8259 24.3386 22.8259 24.6769C22.8259 25.0151 22.7132 25.1279 22.4877 25.1279C22.2622 25.1279 22.1495 25.0151 22.1495 24.6769ZM22.7132 23.6622H22.1495V23.5494H22.3749V22.8729L22.1495 23.0984L22.0367 22.9857L22.2622 22.7602H22.3749V23.5494L22.7132 23.6622ZM22.7132 22.1964H22.1495V22.0837H22.3749V21.4072L22.1495 21.6327L22.0367 21.5199L22.2622 21.2945H22.3749V22.0837L22.7132 22.1964ZM22.3749 19.8287C22.6004 19.8287 22.7132 19.9415 22.7132 20.2797C22.7132 20.618 22.6004 20.7307 22.3749 20.7307C22.1495 20.7307 22.0367 20.618 22.0367 20.2797C22.1495 19.9415 22.2622 19.8287 22.3749 19.8287ZM22.1495 18.7012C22.1495 18.363 22.2622 18.2503 22.4877 18.2503C22.7132 18.2503 22.8259 18.363 22.8259 18.7012C22.8259 19.0395 22.7132 19.1522 22.4877 19.1522C22.2622 19.1522 22.1495 19.0395 22.1495 18.7012ZM22.7132 17.6865H22.1495V17.5738H22.3749V16.8973L22.1495 17.1228L22.0367 17.01L22.2622 16.7845H22.3749V17.5738L22.7132 17.6865ZM22.1495 15.7698C22.1495 15.4316 22.2622 15.3188 22.4877 15.3188C22.7132 15.3188 22.8259 15.4316 22.8259 15.7698C22.8259 16.108 22.7132 16.2208 22.4877 16.2208C22.2622 16.2208 22.1495 15.9953 22.1495 15.7698ZM22.7132 14.6423H22.1495V14.5296H22.3749V13.8531L22.1495 14.0786L22.0367 13.9658L22.2622 13.7403H22.3749V14.5296L22.7132 14.6423ZM22.7132 13.1766H22.1495V13.0639H22.3749V12.3874L22.1495 12.6129L22.0367 12.5001L22.2622 12.2746H22.3749V13.0639L22.7132 13.1766ZM22.7132 11.7109H22.1495V11.5981H22.3749V10.9216L22.1495 11.1471L22.0367 11.0344L22.2622 10.8089H22.3749V11.5981L22.7132 11.7109ZM22.1495 9.68137C22.1495 9.34317 22.2622 9.23037 22.4877 9.23037C22.7132 9.23037 22.8259 9.34317 22.8259 9.68137C22.8259 10.0197 22.7132 10.1324 22.4877 10.1324C22.2622 10.1324 22.1495 10.0197 22.1495 9.68137ZM22.7132 8.66667H22.1495V8.55388H22.3749V7.87738L22.1495 8.10288L22.0367 7.99017L22.2622 7.76467H22.3749V8.55388L22.7132 8.66667ZM22.3749 6.29898C22.6004 6.29898 22.7132 6.41167 22.7132 6.74997C22.7132 7.08817 22.6004 7.20097 22.3749 7.20097C22.1495 7.20097 22.0367 7.08817 22.0367 6.74997C22.1495 6.41167 22.2622 6.29898 22.3749 6.29898ZM22.1495 5.28417C22.1495 4.94597 22.2622 4.83317 22.4877 4.83317C22.7132 4.83317 22.8259 4.94597 22.8259 5.28417C22.8259 5.62247 22.7132 5.73518 22.4877 5.73518C22.2622 5.73518 22.1495 5.50967 22.1495 5.28417ZM22.7132 4.15678H22.1495V4.04397H22.3749V3.36748L22.1495 3.59297L22.0367 3.48028L22.2622 3.25478H22.3749V4.04397L22.7132 4.15678ZM22.1495 2.23997C22.1495 1.90177 22.2622 1.78907 22.4877 1.78907C22.7132 1.78907 22.8259 1.90177 22.8259 2.23997C22.8259 2.57827 22.7132 2.69098 22.4877 2.69098C22.2622 2.69098 22.1495 2.57827 22.1495 2.23997ZM22.7132 1.22528H22.1495V1.11258H22.3749V0.436075L22.1495 0.661575L22.0367 0.548775L22.2622 0.323275H22.3749V1.11258L22.7132 1.22528ZM23.7279 37.1919H23.1642V37.0792H23.3897V36.4027L23.1642 36.6282L23.0514 36.5154L23.2769 36.2899H23.3897V37.0792L23.7279 37.1919ZM23.3897 34.7115C23.6152 34.7115 23.7279 34.8242 23.7279 35.1624C23.7279 35.5007 23.6152 35.6134 23.3897 35.6134C23.1642 35.6134 23.0514 35.5007 23.0514 35.1624C23.1642 34.937 23.1642 34.7115 23.3897 34.7115ZM23.1642 33.6967C23.1642 33.3585 23.2769 33.2457 23.5024 33.2457C23.7279 33.2457 23.8407 33.3585 23.8407 33.6967C23.8407 34.035 23.7279 34.1477 23.5024 34.1477C23.1642 34.1477 23.1642 34.035 23.1642 33.6967ZM23.7279 32.682H23.1642V32.5692H23.3897V31.8928L23.1642 32.1183L23.0514 32.0055L23.2769 31.78H23.3897V32.5692L23.7279 32.682ZM23.7279 28.1721H23.1642V28.0593H23.3897V27.3828L23.1642 27.6083L23.0514 27.4956L23.2769 27.2701H23.3897V28.0593L23.7279 28.1721ZM23.7279 26.7064H23.1642V26.5936H23.3897V25.9171L23.1642 26.1426L23.0514 26.0299L23.2769 25.8044H23.3897V26.5936L23.7279 26.7064ZM23.1642 24.6769C23.1642 24.3386 23.2769 24.2259 23.5024 24.2259C23.7279 24.2259 23.8407 24.3386 23.8407 24.6769C23.8407 25.0151 23.7279 25.1279 23.5024 25.1279C23.2769 25.1279 23.1642 25.0151 23.1642 24.6769ZM23.7279 23.6622H23.1642V23.5494H23.3897V22.8729L23.1642 23.0984L23.0514 22.9857L23.2769 22.7602H23.3897V23.5494L23.7279 23.6622ZM23.7279 19.1522H23.1642V19.0395H23.3897V18.363L23.1642 18.5885L23.0514 18.4758L23.2769 18.2503H23.3897V19.0395L23.7279 19.1522ZM23.7279 17.6865H23.1642V17.5738H23.3897V16.8973L23.1642 17.1228L23.0514 17.01L23.2769 16.7845H23.3897V17.5738L23.7279 17.6865ZM23.1642 15.7698C23.1642 15.4316 23.2769 15.3188 23.5024 15.3188C23.7279 15.3188 23.8407 15.4316 23.8407 15.7698C23.8407 16.108 23.7279 16.2208 23.5024 16.2208C23.2769 16.2208 23.1642 15.9953 23.1642 15.7698ZM23.8407 14.6423H23.2769V14.5296H23.5024V13.8531L23.2769 14.0786L23.1642 13.9658L23.3897 13.7403H23.5024V14.5296L23.8407 14.6423ZM23.8407 13.1766H23.2769V13.0639H23.5024V12.3874L23.2769 12.6129L23.1642 12.5001L23.3897 12.2746H23.5024V13.0639L23.8407 13.1766ZM23.1642 11.2599C23.1642 10.9216 23.2769 10.8089 23.5024 10.8089C23.7279 10.8089 23.8407 10.9216 23.8407 11.2599C23.8407 11.5981 23.7279 11.7109 23.5024 11.7109C23.2769 11.7109 23.1642 11.4854 23.1642 11.2599ZM23.8407 10.1324H23.2769V10.0197H23.5024V9.34317L23.2769 9.56868L23.1642 9.45587L23.3897 9.23037H23.5024V10.0197L23.8407 10.1324ZM23.8407 8.66667H23.2769V8.55388H23.5024V7.87738L23.2769 8.10288L23.1642 7.99017L23.3897 7.76467H23.5024V8.55388L23.8407 8.66667ZM23.8407 7.20097H23.2769V7.08818H23.5024V6.41168L23.2769 6.63718L23.1642 6.52447L23.3897 6.29898H23.5024V7.08818L23.8407 7.20097ZM23.1642 5.28417C23.1642 4.94597 23.2769 4.83317 23.5024 4.83317C23.7279 4.83317 23.8407 4.94597 23.8407 5.28417C23.8407 5.62247 23.7279 5.73518 23.5024 5.73518C23.2769 5.73518 23.1642 5.50967 23.1642 5.28417ZM23.8407 4.15678H23.2769V4.04397H23.5024V3.36748L23.2769 3.59297L23.1642 3.48028L23.3897 3.25478H23.5024V4.04397L23.8407 4.15678ZM24.8554 37.1919H24.2917V37.0792H24.5172V36.4027L24.2917 36.6282L24.1789 36.5154L24.4044 36.2899H24.5172V37.0792L24.8554 37.1919ZM24.8554 35.6134H24.2917V35.5007H24.5172V34.8242L24.2917 35.0497L24.1789 34.9369L24.4044 34.7115H24.5172V35.5007L24.8554 35.6134ZM24.8554 34.1477H24.2917V34.035H24.5172V33.3585L24.2917 33.584L24.1789 33.4712L24.4044 33.2457H24.5172V34.035L24.8554 34.1477ZM24.5172 31.78C24.7427 31.78 24.8554 31.8928 24.8554 32.231C24.8554 32.5692 24.7427 32.682 24.5172 32.682C24.2917 32.682 24.1789 32.5692 24.1789 32.231C24.1789 31.8928 24.2917 31.78 24.5172 31.78ZM24.1789 30.7653C24.1789 30.427 24.2917 30.3143 24.5172 30.3143C24.7427 30.3143 24.8554 30.427 24.8554 30.7653C24.8554 31.1035 24.7427 31.2163 24.5172 31.2163C24.2917 31.2163 24.1789 30.9908 24.1789 30.7653ZM24.8554 29.6378H24.2917V29.5251H24.5172V28.8486L24.2917 29.0741L24.1789 28.9613L24.4044 28.7358H24.5172V29.5251L24.8554 29.6378ZM24.1789 27.7211C24.1789 27.3828 24.2917 27.2701 24.5172 27.2701C24.7427 27.2701 24.8554 27.3828 24.8554 27.7211C24.8554 28.0593 24.7427 28.1721 24.5172 28.1721C24.2917 28.1721 24.1789 28.0593 24.1789 27.7211ZM24.8554 26.7064H24.2917V26.5936H24.5172V25.9171L24.2917 26.1426L24.1789 26.0299L24.4044 25.8044H24.5172V26.5936L24.8554 26.7064ZM24.1789 24.6769C24.1789 24.3386 24.2917 24.2259 24.5172 24.2259C24.7427 24.2259 24.8554 24.3386 24.8554 24.6769C24.8554 25.0151 24.7427 25.1279 24.5172 25.1279C24.2917 25.1279 24.1789 25.0151 24.1789 24.6769ZM24.8554 23.6622H24.2917V23.5494H24.5172V22.8729L24.2917 23.0984L24.1789 22.9857L24.4044 22.7602H24.5172V23.5494L24.8554 23.6622ZM24.8554 22.1964H24.2917V22.0837H24.5172V21.4072L24.2917 21.6327L24.1789 21.5199L24.4044 21.2945H24.5172V22.0837L24.8554 22.1964ZM24.5172 19.8287C24.7427 19.8287 24.8554 19.9415 24.8554 20.2797C24.8554 20.618 24.7427 20.7307 24.5172 20.7307C24.2917 20.7307 24.1789 20.618 24.1789 20.2797C24.1789 19.9415 24.2917 19.8287 24.5172 19.8287ZM24.1789 18.7012C24.1789 18.363 24.2917 18.2503 24.5172 18.2503C24.7427 18.2503 24.8554 18.363 24.8554 18.7012C24.8554 19.0395 24.7427 19.1522 24.5172 19.1522C24.2917 19.1522 24.1789 19.0395 24.1789 18.7012ZM24.8554 17.6865H24.2917V17.5738H24.5172V16.8973L24.2917 17.1228L24.1789 17.01L24.4044 16.7845H24.5172V17.5738L24.8554 17.6865ZM24.1789 15.7698C24.1789 15.4316 24.2917 15.3188 24.5172 15.3188C24.7427 15.3188 24.8554 15.4316 24.8554 15.7698C24.8554 16.108 24.7427 16.2208 24.5172 16.2208C24.2917 16.2208 24.1789 15.9953 24.1789 15.7698ZM24.8554 14.6423H24.2917V14.5296H24.5172V13.8531L24.2917 14.0786L24.1789 13.9658L24.4044 13.7403H24.5172V14.5296L24.8554 14.6423ZM24.8554 13.1766H24.2917V13.0639H24.5172V12.3874L24.2917 12.6129L24.1789 12.5001L24.4044 12.2746H24.5172V13.0639L24.8554 13.1766ZM24.8554 11.7109H24.2917V11.5981H24.5172V10.9216L24.2917 11.1471L24.1789 11.0344L24.4044 10.8089H24.5172V11.5981L24.8554 11.7109ZM24.1789 9.68137C24.1789 9.34317 24.2917 9.23037 24.5172 9.23037C24.7427 9.23037 24.8554 9.34317 24.8554 9.68137C24.8554 10.0197 24.7427 10.1324 24.5172 10.1324C24.2917 10.1324 24.1789 10.0197 24.1789 9.68137ZM24.8554 8.66667H24.2917V8.55388H24.5172V7.87738L24.2917 8.10288L24.1789 7.99017L24.4044 7.76467H24.5172V8.55388L24.8554 8.66667ZM24.5172 6.29898C24.7427 6.29898 24.8554 6.41167 24.8554 6.74997C24.8554 7.08817 24.7427 7.20097 24.5172 7.20097C24.2917 7.20097 24.1789 7.08817 24.1789 6.74997C24.1789 6.41167 24.2917 6.29898 24.5172 6.29898ZM24.1789 5.28417C24.1789 4.94597 24.2917 4.83317 24.5172 4.83317C24.7427 4.83317 24.8554 4.94597 24.8554 5.28417C24.8554 5.62247 24.7427 5.73518 24.5172 5.73518C24.2917 5.73518 24.1789 5.50967 24.1789 5.28417ZM24.8554 4.15678H24.2917V4.04397H24.5172V3.36748L24.2917 3.59297L24.1789 3.48028L24.4044 3.25478H24.5172V4.04397L24.8554 4.15678ZM24.1789 2.23997C24.1789 1.90177 24.2917 1.78907 24.5172 1.78907C24.7427 1.78907 24.8554 1.90177 24.8554 2.23997C24.8554 2.57827 24.7427 2.69098 24.5172 2.69098C24.2917 2.69098 24.1789 2.57827 24.1789 2.23997ZM24.8554 1.22528H24.2917V1.11258H24.5172V0.436075L24.2917 0.661575L24.1789 0.548775L24.4044 0.323275H24.5172V1.11258L24.8554 1.22528Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7425 15.7691V15.6564C24.7425 15.4309 24.7425 15.3181 24.517 15.3181C24.4043 15.3181 24.2915 15.4309 24.2915 15.6564V15.7691C24.2915 15.9946 24.2915 16.1074 24.517 16.1074C24.6298 16.1074 24.7425 15.9946 24.7425 15.7691ZM24.4043 15.7691C24.4043 15.6564 24.4043 15.6564 24.4043 15.7691C24.517 15.6564 24.517 15.6564 24.517 15.7691C24.6298 15.7691 24.517 15.7691 24.4043 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6151 24.7894V24.6766C23.6151 24.4511 23.6151 24.3384 23.3896 24.3384C23.2769 24.3384 23.1641 24.4511 23.1641 24.6766V24.7894C23.1641 25.0149 23.1641 25.1276 23.3896 25.1276C23.6151 25.1276 23.6151 25.0149 23.6151 24.7894ZM23.3896 24.7894C23.3896 24.6766 23.3896 24.6766 23.3896 24.7894C23.5024 24.6766 23.5023 24.6766 23.5023 24.7894C23.5023 24.7894 23.5024 24.7894 23.3896 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3744 5.62231C22.4872 5.62231 22.5999 5.50951 22.5999 5.28401V5.17131C22.5999 4.94581 22.5999 4.83301 22.3744 4.83301C22.2617 4.83301 22.1489 4.94581 22.1489 5.17131V5.28401C22.2617 5.50951 22.2617 5.62231 22.3744 5.62231ZM22.3744 5.17131C22.4872 5.05851 22.4872 5.17131 22.4872 5.17131C22.4872 5.28401 22.4872 5.28401 22.3744 5.17131C22.3744 5.28401 22.3744 5.28401 22.3744 5.17131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3896 34.0348C23.5024 34.0348 23.6151 33.9221 23.6151 33.6966V33.5838C23.6151 33.3584 23.6151 33.2456 23.3896 33.2456C23.2769 33.2456 23.1641 33.3584 23.1641 33.5838V33.6966C23.2769 33.9221 23.2769 34.0348 23.3896 34.0348ZM23.3896 33.6966C23.5024 33.5839 23.5023 33.6966 23.5023 33.6966C23.5023 33.8093 23.5024 33.8093 23.3896 33.6966C23.3896 33.8093 23.3896 33.8093 23.3896 33.6966Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5019 22.083C23.6147 22.083 23.7274 21.9702 23.7274 21.7447V21.632C23.7274 21.4065 23.7274 21.2937 23.5019 21.2937C23.3892 21.2937 23.2764 21.4065 23.2764 21.632V21.7447C23.2764 21.9702 23.2764 22.083 23.5019 22.083ZM23.3892 21.7447C23.3892 21.632 23.3892 21.632 23.3892 21.7447C23.5019 21.632 23.5019 21.7447 23.5019 21.7447C23.5019 21.7447 23.5019 21.7447 23.3892 21.7447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3896 35.6127C23.5024 35.6127 23.6151 35.5 23.6151 35.2745V35.1617C23.6151 34.9362 23.6151 34.8235 23.3896 34.8235C23.2769 34.8235 23.1641 34.9362 23.1641 35.1617V35.2745C23.2769 35.5 23.2769 35.6127 23.3896 35.6127ZM23.3896 35.1617C23.5024 35.049 23.5023 35.1617 23.5023 35.1617C23.5023 35.2745 23.5024 35.2745 23.3896 35.1617C23.3896 35.2745 23.3896 35.2745 23.3896 35.1617Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.517 5.62231C24.6298 5.62231 24.7425 5.50951 24.7425 5.28401V5.17131C24.7425 4.94581 24.7425 4.83301 24.517 4.83301C24.4043 4.83301 24.2915 4.94581 24.2915 5.17131V5.28401C24.2915 5.50951 24.4043 5.62231 24.517 5.62231ZM24.4043 5.17131C24.517 5.05851 24.517 5.17131 24.517 5.17131C24.6298 5.28401 24.517 5.28401 24.4043 5.17131C24.4043 5.28401 24.4043 5.28401 24.4043 5.17131Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5999 9.79377V9.68097C22.5999 9.45547 22.5999 9.34277 22.3744 9.34277C22.2617 9.34277 22.1489 9.45547 22.1489 9.68097V9.79377C22.1489 10.0193 22.1489 10.132 22.3744 10.132C22.5999 10.132 22.5999 10.0193 22.5999 9.79377ZM22.3744 9.79377C22.3744 9.68097 22.3744 9.68097 22.3744 9.79377C22.4872 9.68097 22.4872 9.68097 22.4872 9.79377C22.4872 9.79377 22.4872 9.79377 22.3744 9.79377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3749 7.08754C22.4876 7.08754 22.6004 6.97474 22.6004 6.74934V6.63654C22.6004 6.41104 22.6004 6.29834 22.3749 6.29834C22.2621 6.41104 22.2622 6.52384 22.2622 6.63654V6.74934C22.2622 6.97474 22.2621 7.08754 22.3749 7.08754ZM22.3749 6.74934C22.3749 6.63654 22.3749 6.63654 22.3749 6.74934C22.4876 6.63654 22.4876 6.74934 22.4876 6.74934C22.4876 6.74934 22.4876 6.86204 22.3749 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6151 15.7691V15.6564C23.6151 15.4309 23.6151 15.3181 23.3896 15.3181C23.2769 15.3181 23.1641 15.4309 23.1641 15.6564V15.7691C23.1641 15.9946 23.1641 16.1074 23.3896 16.1074C23.6151 16.1074 23.6151 15.9946 23.6151 15.7691ZM23.3896 15.7691C23.3896 15.6564 23.3896 15.6564 23.3896 15.7691C23.5024 15.6564 23.5023 15.6564 23.5023 15.7691C23.5023 15.7691 23.5024 15.7691 23.3896 15.7691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7425 2.3531V2.2404C24.7425 2.0149 24.7425 1.9021 24.517 1.9021C24.4043 1.9021 24.2915 2.0149 24.2915 2.2404V2.3531C24.2915 2.5786 24.2915 2.6914 24.517 2.6914C24.6298 2.5786 24.7425 2.4659 24.7425 2.3531ZM24.4043 2.2404C24.517 2.1276 24.517 2.1276 24.517 2.2404C24.6298 2.2404 24.517 2.3531 24.4043 2.2404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7425 27.8338V27.7211C24.7425 27.4956 24.7425 27.3828 24.517 27.3828C24.4043 27.3828 24.2915 27.4956 24.2915 27.7211V27.8338C24.2915 28.0593 24.2915 28.172 24.517 28.172C24.6298 28.0593 24.7425 27.9466 24.7425 27.8338ZM24.4043 27.7211C24.517 27.6083 24.517 27.6083 24.517 27.7211C24.6298 27.7211 24.517 27.8338 24.4043 27.7211Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6004 24.7894V24.6766C22.6004 24.4511 22.6004 24.3384 22.3749 24.3384C22.2621 24.3384 22.2622 24.4511 22.2622 24.6766V24.7894C22.2622 25.0149 22.2622 25.1276 22.4876 25.1276C22.6004 25.1276 22.6004 25.0149 22.6004 24.7894ZM22.3749 24.7894C22.3749 24.6766 22.3749 24.6766 22.3749 24.7894C22.4876 24.6766 22.4876 24.6766 22.4876 24.7894C22.4876 24.7894 22.4876 24.7894 22.3749 24.7894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.517 7.08754C24.6298 7.08754 24.7425 6.97474 24.7425 6.74934V6.63654C24.7425 6.41104 24.7425 6.29834 24.517 6.29834C24.4043 6.29834 24.2915 6.41104 24.2915 6.63654V6.74934C24.2915 6.97474 24.4043 7.08754 24.517 7.08754ZM24.4043 6.74934C24.4043 6.63654 24.4043 6.63654 24.4043 6.74934C24.517 6.63654 24.517 6.74934 24.517 6.74934C24.6298 6.74934 24.517 6.86204 24.4043 6.74934Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_38_877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 37
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7915 28.961V36.4023H25.0811V28.961H12.7915ZM12.7915 22.1961H21.2476V15.995H12.7915V22.1961ZM19.2182 0.886719V3.36722H15.6102V0.886719H12.7915V9.34282H24.2918V3.81822V3.36722V0.886719H19.2182Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_38_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.517 19.0397C24.6298 19.0397 24.7425 18.927 24.7425 18.7015V18.5888C24.7425 18.3633 24.7425 18.2505 24.517 18.2505C24.4043 18.2505 24.2915 18.3633 24.2915 18.5888V18.8143C24.2915 18.927 24.4043 19.0397 24.517 19.0397ZM24.4043 18.7015C24.517 18.5888 24.517 18.7015 24.517 18.7015C24.6298 18.8143 24.517 18.8143 24.4043 18.7015C24.4043 18.8143 24.4043 18.8143 24.4043 18.7015Z",
    fill: "white"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9024 15.9954H4.44629V22.1965H12.9024V15.9954Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0839 0.886719V3.47992H6.36315V0.886719H1.28955V3.47992V3.81822V9.34282H12.7897V0.886719H10.0839Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 36.403H12.7895V36.2903V28.9617H0.5V36.403Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0411 28.9598L83.9331 11.0329H74.5751V14.979H72.9961V9.56714H85.6241V11.0329L77.8451 28.9598H76.0411Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9514 22.0821V21.4056C69.9514 17.234 67.6965 14.3025 63.7503 14.3025C60.1424 14.3025 57.7747 16.783 57.5492 20.9546H55.9707V22.1949H57.5492C57.6619 26.7048 60.0296 29.4107 63.9758 29.4107C66.7945 29.4107 68.7112 27.945 69.6132 25.9155L68.373 25.1263C67.5837 27.043 66.0053 27.945 63.9758 27.945C61.0444 27.945 59.2404 25.9155 59.2404 22.8714V22.1949H69.9514V22.0821ZM59.2404 20.7291C59.2404 17.685 61.0444 15.6555 63.8631 15.6555C66.569 15.6555 68.2602 17.685 68.2602 20.7291V20.9546H59.2404V20.7291Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4613 27.3811L47.1768 20.3907H47.6278C50.7848 20.1652 52.3632 18.2485 52.3632 15.0916C52.3632 11.7091 50.5593 9.67969 47.0641 9.67969H40.0737V28.9596H41.7649V20.3907H45.3729L50.4465 28.9596H52.3632H53.4907V27.3811H51.4613ZM41.8777 19.0377V11.0326H47.1768C49.4318 11.0326 50.672 12.4984 50.672 14.4151V15.7681C50.672 17.6848 49.4318 19.1505 47.1768 19.1505H41.8777V19.0377Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M143.791 29.4048C142.392 29.4048 141.161 29.1716 140.098 28.7052C139.053 28.2202 138.139 27.5019 137.355 26.5505L138.055 25.9628C138.782 26.8583 139.603 27.5206 140.517 27.9496C141.45 28.3601 142.541 28.5653 143.791 28.5653C145.209 28.5653 146.347 28.2948 147.205 27.7538C148.082 27.1941 148.521 26.3359 148.521 25.1793C148.521 24.6756 148.437 24.2558 148.269 23.92C148.101 23.5842 147.858 23.3137 147.541 23.1085C147.224 22.8846 146.842 22.7167 146.394 22.6048C145.946 22.4742 145.452 22.3716 144.911 22.297L142.672 21.9892C142.056 21.8959 141.469 21.784 140.909 21.6534C140.349 21.5041 139.855 21.2896 139.426 21.0098C139.016 20.7299 138.68 20.3755 138.419 19.9464C138.176 19.4986 138.055 18.939 138.055 18.2674C138.055 17.5585 138.195 16.9521 138.475 16.4484C138.754 15.9447 139.128 15.5343 139.594 15.2172C140.079 14.9 140.639 14.6668 141.273 14.5176C141.926 14.3683 142.616 14.2937 143.344 14.2937C144.034 14.2937 144.659 14.359 145.219 14.4896C145.797 14.6015 146.31 14.7694 146.758 14.9933C147.224 15.1985 147.634 15.441 147.989 15.7209C148.362 15.9821 148.689 16.2619 148.968 16.5604L148.297 17.232C148.073 16.9708 147.812 16.719 147.513 16.4764C147.215 16.2153 146.86 15.9914 146.45 15.8048C146.058 15.5996 145.601 15.441 145.079 15.3291C144.575 15.1985 143.987 15.1332 143.316 15.1332C142.01 15.1332 140.965 15.3851 140.182 15.8888C139.417 16.3738 139.034 17.148 139.034 18.2114C139.034 18.7151 139.118 19.1349 139.286 19.4707C139.454 19.7878 139.697 20.0583 140.014 20.2822C140.331 20.4874 140.713 20.6553 141.161 20.7859C141.609 20.8978 142.103 20.9911 142.644 21.0657L144.911 21.4015C145.526 21.4948 146.105 21.6161 146.646 21.7653C147.205 21.8959 147.69 22.1011 148.101 22.3809C148.53 22.6421 148.866 22.9966 149.108 23.4443C149.369 23.892 149.5 24.4517 149.5 25.1233C149.5 25.8509 149.351 26.4852 149.052 27.0262C148.772 27.5672 148.381 28.0149 147.877 28.3694C147.373 28.7052 146.767 28.9571 146.058 29.125C145.368 29.3115 144.612 29.4048 143.791 29.4048Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M123.053 8.35986H124.033V16.8388H124.117C124.452 16.1672 124.993 15.5796 125.74 15.0759C126.486 14.5535 127.447 14.2924 128.622 14.2924C130.45 14.2924 131.877 14.9266 132.903 16.1952C133.929 17.4638 134.442 19.348 134.442 21.8479C134.442 24.3477 133.929 26.232 132.903 27.5005C131.877 28.7691 130.45 29.4034 128.622 29.4034C127.447 29.4034 126.486 29.1516 125.74 28.6479C124.993 28.1255 124.452 27.5285 124.117 26.8569H124.033V29.0676H123.053V8.35986ZM128.398 28.5359C130.002 28.5359 131.234 28.0136 132.092 26.9689C132.95 25.9055 133.379 24.469 133.379 22.6594V21.0364C133.379 19.2268 132.95 17.7996 132.092 16.7549C131.234 15.6915 130.002 15.1598 128.398 15.1598C127.82 15.1598 127.269 15.2438 126.747 15.4117C126.225 15.5796 125.758 15.8221 125.348 16.1393C124.956 16.4564 124.639 16.8388 124.396 17.2866C124.154 17.7343 124.033 18.2287 124.033 18.7697V24.9261C124.033 25.4671 124.154 25.9615 124.396 26.4092C124.639 26.8569 124.956 27.2394 125.348 27.5565C125.758 27.8737 126.225 28.1162 126.747 28.2841C127.269 28.452 127.82 28.5359 128.398 28.5359Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M117.511 29.069C117.082 29.069 116.774 28.9664 116.587 28.7612C116.401 28.556 116.298 28.2668 116.28 27.8937V26.8583H116.168C115.832 27.5672 115.291 28.1735 114.545 28.6772C113.798 29.1623 112.772 29.4048 111.466 29.4048C109.918 29.4048 108.724 29.0503 107.884 28.3414C107.045 27.6325 106.625 26.6251 106.625 25.3192C106.625 24.7222 106.719 24.1719 106.905 23.6682C107.092 23.1645 107.409 22.7354 107.857 22.3809C108.304 22.0078 108.892 21.728 109.619 21.5414C110.347 21.3362 111.243 21.2336 112.306 21.2336H116.252V19.1628C116.252 17.801 115.888 16.7936 115.16 16.1406C114.451 15.4877 113.472 15.1612 112.222 15.1612C111.215 15.1612 110.328 15.3757 109.564 15.8048C108.799 16.2153 108.22 16.8682 107.829 17.7637L107.101 17.288C107.493 16.3925 108.108 15.6742 108.948 15.1332C109.806 14.5736 110.907 14.2937 112.25 14.2937C113.817 14.2937 115.039 14.7135 115.916 15.553C116.793 16.3738 117.231 17.5398 117.231 19.0509V28.2015H119.526V29.069H117.511ZM111.55 28.5653C112.185 28.5653 112.782 28.4907 113.341 28.3414C113.92 28.1735 114.423 27.9403 114.852 27.6418C115.281 27.3247 115.617 26.9422 115.86 26.4945C116.121 26.0468 116.252 25.5244 116.252 24.9274V22.0172H112.334C110.674 22.0172 109.48 22.2877 108.752 22.8287C108.043 23.351 107.689 24.0413 107.689 24.8995V25.739C107.689 26.6531 108.043 27.3527 108.752 27.8377C109.461 28.3228 110.394 28.5653 111.55 28.5653Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2202 29.0669V9.53442H94.2272V28.1434H104.134V29.0669H93.2202Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRe7);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/re7.f66f29547c99a1814293796235d8c076.svg";